<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container modal-lg">
      <div class="modal-header">
        <div>
          <h6 class="mb-0">{{ tituloModal }}</h6>
          <small v-if="!isVisualizacao" class="modal-subtitle">
            {{ etapa === 'revisao' ? 'Revise os dados antes de confirmar.' : 'Selecione os lançamentos do sistema para conciliar.' }}
          </small>
        </div>

        <i class="bi bi-x-circle close-icon" @click="$emit('close')"></i>
      </div>

      <div class="modal-content">
        <!-- Cabeçalho visual -->
        <div class="conciliation-summary-grid mb-3">
          <div class="summary-card summary-card--source">
            <div class="summary-card__label">{{ origemTipoLabel }}</div>
            <div class="summary-card__value">
              {{ formatCurrency(valorItem) }}
            </div>
            <div class="summary-card__meta">
              ID item: {{ item?.id || '—' }}
            </div>

            <div v-if="origemTipo === 'OPERADORA'" class="summary-card__meta">
              Autorização: {{ item?.autorizacao || '—' }}
            </div>

            <div v-if="origemTipo === 'OFX'" class="summary-card__meta">
              Movimento: {{ formatDate(item?.dt_movimento) }}
            </div>
            <div
              v-if="origemTipo === 'OFX' && memoItemBanco"
              class="summary-card__memo"
            >
              {{ memoItemBanco }}
            </div>            
          </div>

          <div class="summary-card">
            <div class="summary-card__label">
              {{ temConciliacaoCompostaDetalhe || revisaoTipo === 'composta' || temAjustePagamentoComposta ? 'Saldo líquido conciliado' : 'Sistema selecionado' }}
            </div>

            <div class="summary-card__value">
              {{ formatCurrency(valorSistemaResumo) }}
            </div>

            <div class="summary-card__meta">
              {{ selecionados.length }} lançamento(s) vinculado(s)
            </div>
          </div>

          <div class="summary-card" :class="differenceCardClass">
            <div class="summary-card__label">Diferença</div>

            <div class="summary-card__value">
              {{ formatCurrency(diferencaResumo) }}
            </div>

            <div class="summary-card__meta">
              {{ diferencaMensagemResumo }}
            </div>
          </div>
        </div>

        <div v-if="!isVisualizacao" class="flow-steps mb-3">
          <div class="flow-step" :class="{ active: etapa === 'selecao', done: etapa === 'revisao' }">
            <span>1</span>
            Seleção
          </div>

          <div class="flow-step" :class="{ active: etapa === 'revisao' }">
            <span>2</span>
            Revisão
          </div>
        </div>

        <div
          v-if="exibirBlocoTaxaOperadora"
          class="info-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Taxa da operadora</strong>
            <span
              class="status-badge"
              :class="props.taxaOperadora ? 'is-green' : 'is-gray'"
            >
              {{ props.taxaOperadora ? taxaOperadoraStatusLabel : 'Não gerada' }}
            </span>
          </div>

          <template v-if="props.taxaOperadora">
            <div><strong>Valor da taxa:</strong> {{ formatCurrency(props.taxaOperadora.valor_taxa) }}</div>
            <div><strong>Descrição:</strong> {{ props.taxaOperadora.descricao_gerada || '—' }}</div>
            <div><strong>Vencimento:</strong> {{ formatDate(props.taxaOperadora.data_vencimento) }}</div>
            <div><strong>Forma de pagamento:</strong> {{ props.taxaOperadora.forma_pagamento_nome || '—' }}</div>
            <div><strong>Plano de contas:</strong> {{ props.taxaOperadora.plano_conta_nome || '—' }}</div>
            <div><strong>Subconta:</strong> {{ props.taxaOperadora.subconta_nome || '—' }}</div>
            <div><strong>ID despesa:</strong> {{ props.taxaOperadora.despesa_id || '—' }}</div>
            <div><strong>ID pagamento da despesa:</strong> {{ props.taxaOperadora.despesa_pagamento_id || '—' }}</div>
            <div><strong>Origem:</strong> {{ formatarOrigemTaxa(props.taxaOperadora.origem_status_conciliacao) }}</div>
          </template>

          <template v-else>
            <div class="text-muted">
              Nenhuma taxa automática foi gerada para este item.
            </div>
          </template>
        </div>

        <div
          v-if="isVisualizacao && temChequeDevolvido"
          class="info-box cheque-devolvido-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Conciliação de cheque devolvido</strong>
            <span class="status-badge is-red">Cheque devolvido</span>
          </div>

          <div
            v-for="vinc in vinculadosChequeDevolvido"
            :key="`${vinc.origem_tabela}-${vinc.origem_id}`"
            class="mb-2"
          >
            <div><strong>Origem:</strong> {{ vinc.descricao || vinc.origem_tabela }}</div>
            <div><strong>Cheque:</strong> {{ vinc.cheque_numero || vinc.cheque_evento_cheque_numero || '—' }}</div>
            <div><strong>Status do cheque:</strong> {{ formatChequeStatus(vinc.cheque_status) }}</div>
            <div><strong>Data da devolução:</strong> {{ formatDate(vinc.cheque_evento_data || vinc.cheque_data_devolucao) }}</div>
            <div><strong>Valor utilizado:</strong> {{ formatCurrency(vinc.valor_utilizado || vinc.cheque_evento_valor || vinc.valor) }}</div>

            <div v-if="vinc.cheque_evento_motivo">
              <strong>Motivo:</strong> {{ vinc.cheque_evento_motivo }}
            </div>

            <div v-if="vinc.observacao_conciliacao">
              <strong>Observação:</strong> {{ vinc.observacao_conciliacao }}
            </div>
          </div>

        </div>

        <div
          v-if="isVisualizacao && temChequeReapresentado"
          class="info-box cheque-reapresentado-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Conciliação de cheque reapresentado</strong>
            <span class="status-badge is-amber">Cheque reapresentado</span>
          </div>

          <div
            v-for="vinc in vinculadosChequeReapresentado"
            :key="`${vinc.origem_tabela}-${vinc.origem_id}-${vinc.vinculo_id}`"
            class="mb-2"
          >
            <div><strong>Origem:</strong> {{ vinc.descricao || vinc.origem_tabela }}</div>
            <div><strong>Cheque:</strong> {{ vinc.cheque_numero || vinc.cheque_evento_cheque_numero || '—' }}</div>
            <div><strong>Status do cheque:</strong> {{ formatChequeStatus(vinc.cheque_status) }}</div>
            <div><strong>Data da reapresentação:</strong> {{ formatDate(vinc.cheque_evento_data || vinc.cheque_data_reapresentacao || props.item?.dt_movimento) }}</div>
            <div><strong>Valor utilizado:</strong> {{ formatCurrency(getValorConsideradoConciliacao(vinc)) }}</div>

            <div v-if="vinc.cheque_evento_motivo">
              <strong>Histórico bancário:</strong> {{ vinc.cheque_evento_motivo }}
            </div>

            <div v-if="vinc.observacao_conciliacao">
              <strong>Observação:</strong> {{ vinc.observacao_conciliacao }}
            </div>
          </div>
        </div>        

        <div
          v-if="isVisualizacao && temDepositoChequeAgrupado"
          class="info-box deposito-cheque-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Depósito agrupado de cheques</strong>
            <span class="status-badge is-blue">
              {{ quantidadeChequesFisicosDeposito }} cheque(s) físico(s) · {{ vinculadosDepositoChequeAgrupado.length }} lançamento(s)
            </span>
          </div>

          <div class="deposito-cheque-resumo mb-2">
            <div>
              <span>Total do banco</span>
              <strong>{{ formatCurrency(valorItem) }}</strong>
            </div>

            <div>
              <span>Total dos cheques</span>
              <strong>{{ formatCurrency(totalDepositoChequeAgrupado) }}</strong>
            </div>

            <div>
              <span>Diferença</span>
              <strong :class="Math.abs(diferencaDepositoChequeAgrupado) <= 0.01 ? 'diff-ok' : 'diff-alert'">
                {{ formatCurrency(diferencaDepositoChequeAgrupado) }}
              </strong>
            </div>
          </div>

          <div class="deposito-cheque-lista">
            <div
              v-for="vinc in vinculadosDepositoChequeAgrupado"
              :key="`${vinc.origem_tabela}-${vinc.origem_id}-${vinc.vinculo_id}`"
              class="deposito-cheque-item"
            >
              <div class="deposito-cheque-item__main">
                <div>
                  <strong>{{ vinc.descricao || vinc.origem_tabela }}</strong>

                  <small class="text-muted d-block">
                    {{ formatDate(vinc.dt_caixa) }} · {{ vinc.forma_pagamento_nome || 'Cheque' }}
                  </small>
                </div>

                <div class="deposito-cheque-item__valor">
                  {{ formatCurrency(vinc.valor_utilizado || vinc.valor) }}
                </div>
              </div>

              <div class="deposito-cheque-grid mt-2">
                <div>
                  <span>Cheque</span>
                  <strong>{{ vinc.cheque_numero || '—' }}</strong>
                </div>

                <div>
                  <span>Status</span>
                  <strong>{{ formatChequeStatus(vinc.cheque_status) }}</strong>
                </div>

                <div>
                  <span>Recebimento</span>
                  <strong>{{ formatDate(vinc.dt_caixa) }}</strong>
                </div>

                <div v-if="vinc.cheque_data_devolucao">
                  <span>Devolução</span>
                  <strong>{{ formatDate(vinc.cheque_data_devolucao) }}</strong>
                </div>

                <div v-if="vinc.cheque_data_reapresentacao">
                  <span>Reapresentação</span>
                  <strong>{{ formatDate(vinc.cheque_data_reapresentacao) }}</strong>
                </div>

                <div v-if="vinc.cheque_data_compensacao">
                  <span>Compensação</span>
                  <strong>{{ formatDate(vinc.cheque_data_compensacao) }}</strong>
                </div>

                <div v-if="vinc.cheque_data_substituicao">
                  <span>Substituição</span>
                  <strong>{{ formatDate(vinc.cheque_data_substituicao) }}</strong>
                </div>
              </div>

              <div class="mt-2">
                <span
                  v-if="chequeFoiDevolvidoDepoisDoDeposito(vinc)"
                  class="status-badge is-red me-1"
                >
                  Devolvido posteriormente
                </span>

                <span
                  v-if="chequeFoiReapresentado(vinc)"
                  class="status-badge is-amber me-1"
                >
                  Reapresentado
                </span>

                <span
                  v-if="!chequeFoiDevolvidoDepoisDoDeposito(vinc) && !chequeFoiReapresentado(vinc)"
                  class="status-badge is-gray me-1"
                >
                  Depositado
                </span>
              </div>

              <div
                v-if="vinc.cheque_motivo_devolucao || vinc.cheque_observacao || vinc.observacao_conciliacao"
                class="deposito-cheque-observacao mt-2"
              >
                <div v-if="vinc.cheque_motivo_devolucao">
                  <strong>Motivo devolução:</strong> {{ vinc.cheque_motivo_devolucao }}
                </div>

                <div v-if="vinc.cheque_observacao">
                  <strong>Observação do cheque:</strong> {{ vinc.cheque_observacao }}
                </div>

                <div v-if="vinc.observacao_conciliacao">
                  <strong>Observação da conciliação:</strong> {{ vinc.observacao_conciliacao }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isVisualizacao && temAjustePix"
          class="info-box pix-ajuste-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Ajuste realizado na conciliação PIX</strong>
            <span class="status-badge is-orange">PIX ajustado</span>
          </div>

          <div
            v-for="ajuste in vinculadosComAjustePix"
            :key="ajuste.vinculo_id"
            class="mb-2"
          >
            <div>
              <strong>Pessoa identificada:</strong>
              {{ ajuste.ajuste_pix_payload?.pix_pessoa_nome || '—' }}
            </div>

            <div>
              <strong>Identificador PIX:</strong>
              {{ ajuste.ajuste_pix_payload?.pix_identificador || '—' }}
              <span v-if="ajuste.ajuste_pix_payload?.pix_match_campo">
                — {{ ajuste.ajuste_pix_payload.pix_match_campo }}
              </span>
            </div>

            <div class="ajuste-grid mt-2">
              <div class="ajuste-card">
                <div class="ajuste-card-title">Antes</div>
                <div><strong>Valor:</strong> {{ formatCurrency(ajuste.ajuste_pix_payload?.pagamento_antes?.valor) }}</div>
                <div><strong>Forma:</strong> {{ ajuste.ajuste_pix_payload?.pagamento_antes?.forma_pagamento_nome || '—' }}</div>
                <div><strong>Data pagamento:</strong> {{ formatDate(ajuste.ajuste_pix_payload?.pagamento_antes?.data_pagamento) }}</div>
                <div><strong>Data recebimento:</strong> {{ formatDate(ajuste.ajuste_pix_payload?.pagamento_antes?.data_recebimento) }}</div>
                <div><strong>Conta:</strong> {{ ajuste.ajuste_pix_payload?.pagamento_antes?.conta_financeira_id || '—' }}</div>
              </div>

              <div class="ajuste-card">
                <div class="ajuste-card-title">Depois</div>
                <div><strong>Valor:</strong> {{ formatCurrency(ajuste.ajuste_pix_payload?.pagamento_depois?.valor) }}</div>
                <div><strong>Forma:</strong> {{ ajuste.ajuste_pix_payload?.pagamento_depois?.forma_pagamento_nome || '—' }}</div>
                <div><strong>Data pagamento:</strong> {{ formatDate(ajuste.ajuste_pix_payload?.pagamento_depois?.data_pagamento) }}</div>
                <div><strong>Data recebimento:</strong> {{ formatDate(ajuste.ajuste_pix_payload?.pagamento_depois?.data_recebimento) }}</div>
                <div><strong>Conta:</strong> {{ ajuste.ajuste_pix_payload?.pagamento_depois?.conta_financeira_id || '—' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isVisualizacao && temReceitaCriadaConciliacao"
          class="info-box receita-criada-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Receita criada pela conciliação</strong>
            <span class="status-badge is-green">Receita criada</span>
          </div>

          <div
            v-for="receita in vinculadosComReceitaCriada"
            :key="receita.vinculo_id"
            class="mb-2"
          >
            <div class="receita-criada-grid">
              <div>
                <span class="receita-criada-label">Descrição</span>
                <strong>{{ receita.receita_criada_payload?.descricao || receita.descricao || '—' }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Valor</span>
                <strong>{{ formatCurrency(receita.receita_criada_payload?.valor || receita.valor) }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Data</span>
                <strong>{{ formatDate(receita.receita_criada_payload?.data || receita.dt_caixa) }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Forma</span>
                <strong>{{ receita.receita_criada_payload?.forma_pagamento_nome || receita.forma_pagamento_nome || '—' }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Receita Geral</span>
                <strong>#{{ receita.receita_criada_payload?.receita_geral_id || '—' }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Pagamento</span>
                <strong>#{{ receita.receita_criada_payload?.receita_pagamento_id || receita.origem_id || '—' }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Subconta</span>
                <strong>
                  {{ receita.receita_criada_payload?.subconta_nome || '—' }}
                  <span v-if="receita.receita_criada_payload?.subconta_id">
                    #{{ receita.receita_criada_payload.subconta_id }}
                  </span>
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Plano de contas</span>
                <strong>{{ receita.receita_criada_payload?.plano_conta_nome || '—' }}</strong>
              </div>

              <div>
                <span class="receita-criada-label">Conta financeira</span>
                <strong>
                  {{ receita.receita_criada_payload?.conta_financeira_nome || '—' }}
                  <span v-if="receita.receita_criada_payload?.conta_financeira_id">
                    #{{ receita.receita_criada_payload.conta_financeira_id }}
                  </span>
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Instituição</span>
                <strong>
                  {{ receita.receita_criada_payload?.conta_financeira_instituicao || '—' }}
                  <span v-if="receita.receita_criada_payload?.conta_financeira_numero">
                    · {{ receita.receita_criada_payload.conta_financeira_numero }}
                  </span>
                </strong>
              </div>
            </div>

            <div
              v-if="receita.receita_criada_payload?.pix_pessoa_nome || receita.receita_criada_payload?.pix_identificador"
              class="receita-criada-pix mt-2"
            >
              <div>
                <strong>Pessoa identificada:</strong>
                {{ receita.receita_criada_payload?.pix_pessoa_nome || '—' }}
              </div>

              <div>
                <strong>Identificador PIX:</strong>
                {{ receita.receita_criada_payload?.pix_identificador || '—' }}
                <span v-if="receita.receita_criada_payload?.pix_match_campo">
                  — {{ receita.receita_criada_payload.pix_match_campo }}
                </span>
              </div>
            </div>

            <div
              v-if="receita.receita_criada_payload?.observacao"
              class="receita-criada-observacao mt-2"
            >
              <strong>Observação:</strong>
              {{ receita.receita_criada_payload.observacao }}
            </div>
          </div>
        </div>      

        <div
          v-if="isVisualizacao && temReceitaAbatimentoCriada"
          class="info-box receita-abatimento-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Receita de abatimento criada pela conciliação</strong>
            <span class="status-badge is-green">Abatimento criado</span>
          </div>

          <div
            v-for="receita in vinculadosComReceitaAbatimentoCriada"
            :key="receita.vinculo_id"
            class="mb-2"
          >
            <div class="receita-criada-grid">
              <div>
                <span class="receita-criada-label">Descrição</span>
                <strong>
                  {{ receita.receita_abatimento_criada_payload?.descricao || receita.descricao || '—' }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Valor abatido</span>
                <strong>
                  {{ formatCurrency(receita.receita_abatimento_criada_payload?.valor || receita.valor_utilizado || receita.valor) }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Data</span>
                <strong>
                  {{ formatDate(receita.receita_abatimento_criada_payload?.data || receita.dt_caixa) }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Forma</span>
                <strong>
                  {{ receita.receita_abatimento_criada_payload?.forma_pagamento_nome || receita.forma_pagamento_nome || '—' }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Receita Geral</span>
                <strong>
                  #{{ receita.receita_abatimento_criada_payload?.receita_geral_id || '—' }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Pagamento</span>
                <strong>
                  #{{ receita.receita_abatimento_criada_payload?.receita_pagamento_id || receita.origem_id || '—' }}
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Subconta</span>
                <strong>
                  <span v-if="receita.receita_abatimento_criada_payload?.subconta_nome">
                    {{ receita.receita_abatimento_criada_payload.subconta_nome }}
                  </span>
                  <span v-else>
                    #{{ receita.receita_abatimento_criada_payload?.subconta_id || '—' }}
                  </span>
                </strong>
              </div>

              <div>
                <span class="receita-criada-label">Papel na composição</span>
                <strong>Abate o pagamento</strong>
              </div>
            </div>

            <div
              v-if="receita.receita_abatimento_criada_payload?.observacao"
              class="receita-criada-observacao mt-2"
            >
              <strong>Observação:</strong>
              {{ receita.receita_abatimento_criada_payload.observacao }}
            </div>
          </div>
        </div>    
        
        <div
          v-if="isVisualizacao && temAjustePagamentoDetalhe"
          class="info-box ajuste-pagamento-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Pagamento ajustado pela conciliação</strong>
            <span class="status-badge is-orange">Juros / Multa / Desconto</span>
          </div>

          <div
            v-for="ajuste in vinculadosComAjustePagamento"
            :key="`ajuste-pagamento-detalhe-${ajuste.vinculo_id}`"
            class="mb-2"
          >
            <div class="ajuste-pagamento-grid">
              <div>
                <span class="ajuste-pagamento-label">Despesa</span>
                <strong>{{ ajuste.descricao || ajuste.origem_tabela || '—' }}</strong>
              </div>

              <div>
                <span class="ajuste-pagamento-label">Valor original</span>
                <strong>{{ formatCurrency(ajuste.ajuste_pagamento_payload?.valor_original) }}</strong>
              </div>

              <div>
                <span class="ajuste-pagamento-label">Juros</span>
                <strong>{{ formatCurrency(ajuste.ajuste_pagamento_payload?.juros) }}</strong>
              </div>

              <div>
                <span class="ajuste-pagamento-label">Multa</span>
                <strong>{{ formatCurrency(ajuste.ajuste_pagamento_payload?.multa) }}</strong>
              </div>

              <div>
                <span class="ajuste-pagamento-label">Desconto</span>
                <strong>{{ formatCurrency(ajuste.ajuste_pagamento_payload?.desconto) }}</strong>
              </div>

              <div>
                <span class="ajuste-pagamento-label">Valor líquido conciliado</span>
                <strong>{{ formatCurrency(ajuste.ajuste_pagamento_payload?.valor_liquido || ajuste.valor_utilizado) }}</strong>
              </div>
            </div>

            <div
              v-if="ajuste.ajuste_pagamento_payload?.observacao"
              class="ajuste-pagamento-observacao mt-2"
            >
              <strong>Observação do ajuste:</strong>
              {{ ajuste.ajuste_pagamento_payload.observacao }}
            </div>
          </div>
        </div>        
        
        <div
          v-if="isVisualizacao && temDespesaCriadaConciliacao"
          class="info-box despesa-criada-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Despesa criada pela conciliação</strong>
            <span class="status-badge is-orange">Despesa criada</span>
          </div>

          <div
            v-for="despesa in vinculadosComDespesaCriada"
            :key="despesa.vinculo_id"
            class="mb-2"
          >
            <div class="despesa-criada-grid">
              <div>
                <span class="despesa-criada-label">Descrição</span>
                <strong>{{ despesa.despesa_criada_payload?.descricao || despesa.descricao || '—' }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Valor</span>
                <strong>{{ formatCurrency(despesa.despesa_criada_payload?.valor || despesa.valor) }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Data</span>
                <strong>{{ formatDate(despesa.despesa_criada_payload?.data || despesa.dt_caixa) }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Forma</span>
                <strong>{{ despesa.despesa_criada_payload?.forma_pagamento_nome || despesa.forma_pagamento_nome || '—' }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Despesa</span>
                <strong>#{{ despesa.despesa_criada_payload?.despesa_id || '—' }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Pagamento</span>
                <strong>#{{ despesa.despesa_criada_payload?.despesa_pagamento_id || despesa.origem_id || '—' }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Subconta</span>
                <strong>
                  {{ despesa.despesa_criada_payload?.subconta_nome || '—' }}
                  <span v-if="despesa.despesa_criada_payload?.subconta_id">
                    #{{ despesa.despesa_criada_payload.subconta_id }}
                  </span>
                </strong>
              </div>

              <div>
                <span class="despesa-criada-label">Plano de contas</span>
                <strong>{{ despesa.despesa_criada_payload?.plano_conta_nome || '—' }}</strong>
              </div>

              <div>
                <span class="despesa-criada-label">Conta financeira</span>
                <strong>
                  {{ despesa.despesa_criada_payload?.conta_financeira_nome || '—' }}
                  <span v-if="despesa.despesa_criada_payload?.conta_financeira_id">
                    #{{ despesa.despesa_criada_payload.conta_financeira_id }}
                  </span>
                </strong>
              </div>

              <div>
                <span class="despesa-criada-label">Instituição</span>
                <strong>
                  {{ despesa.despesa_criada_payload?.conta_financeira_instituicao || '—' }}
                  <span v-if="despesa.despesa_criada_payload?.conta_financeira_numero">
                    · {{ despesa.despesa_criada_payload.conta_financeira_numero }}
                  </span>
                </strong>
              </div>
            </div>

            <div
              v-if="despesa.despesa_criada_payload?.observacao"
              class="despesa-criada-observacao mt-2"
            >
              <strong>Observação:</strong>
              {{ despesa.despesa_criada_payload.observacao }}
            </div>
          </div>
        </div>

        <div
          v-if="temConsolidadoParcialDetalhe"
          class="info-box consolidado-parcial-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Conciliação parcial</strong>
            <span class="status-badge is-amber">Vínculo parcial</span>
          </div>

          <div
            v-for="vinc in vinculadosConsolidadoParcial"
            :key="`${vinc.origem_tabela}-${vinc.origem_id}-${vinc.vinculo_id}`"
            class="mb-2"
          >
            <div><strong>Origem:</strong> {{ vinc.descricao || vinc.origem_tabela }}</div>
            <div><strong>Valor original:</strong> {{ formatCurrency(vinc.valor) }}</div>
            <div><strong>Valor utilizado:</strong> {{ formatCurrency(vinc.valor_utilizado) }}</div>

            <div v-if="vinc.observacao_conciliacao">
              <strong>Observação:</strong> {{ vinc.observacao_conciliacao }}
            </div>
          </div>
        </div>

        <div
          v-if="temConciliacaoCompostaDetalhe"
          class="info-box conciliacao-composta-detalhe-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Conciliação composta</strong>
            <span class="status-badge is-blue">
              {{ vinculadosConciliacaoComposta.length }} vínculo(s)
            </span>
          </div>

          <div class="composta-detalhe-resumo mb-3">
            <div>
              <span>Valor banco</span>
              <strong>{{ formatCurrency(valorItem) }}</strong>
            </div>

            <div>
              <span>Total receitas</span>
              <strong>{{ formatCurrency(totalReceitasCompoemDetalhe + totalReceitasAbatemDetalhe) }}</strong>
            </div>

            <div>
              <span>Total despesas</span>
              <strong>{{ formatCurrency(totalDespesasCompoemDetalhe + totalDespesasAbatemDetalhe) }}</strong>
            </div>

            <div>
              <span>Saldo líquido</span>
              <strong>{{ formatCurrency(saldoLiquidoConciliacaoCompostaDetalhe) }}</strong>
            </div>

            <div>
              <span>Diferença</span>
              <strong :class="Math.abs(diferencaConciliacaoCompostaDetalhe) <= 0.01 ? 'diff-ok' : 'diff-alert'">
                {{ formatCurrency(diferencaConciliacaoCompostaDetalhe) }}
              </strong>
            </div>
          </div>

          <div class="composta-detalhe-lista">
            <div
              v-for="vinc in vinculadosConciliacaoComposta"
              :key="`${vinc.origem_tabela}-${vinc.origem_id}-${vinc.vinculo_id}`"
              class="composta-detalhe-item"
            >
              <div class="composta-detalhe-item__main">
                <div>
                  <strong>{{ vinc.descricao || vinc.origem_tabela }}</strong>

                  <small class="text-muted d-block">
                    {{ formatDate(vinc.dt_caixa) }} · {{ vinc.forma_pagamento_nome || 'Forma não informada' }}
                  </small>

                  <small class="text-muted d-block">
                    {{ vinc.origem_tabela }} #{{ vinc.origem_id }}
                  </small>
                </div>

                <div class="composta-detalhe-item__valor text-end">
                  <template v-if="vinc.ajuste_pagamento_conciliacao">
                    <small class="text-muted d-block">Valor líquido</small>
                    <strong>
                      {{ formatCurrency(vinc.ajuste_pagamento_payload?.valor_liquido || vinc.valor_utilizado || vinc.valor) }}
                    </strong>

                    <small class="text-muted d-block mt-1">Valor original</small>
                    <span>
                      {{ formatCurrency(vinc.ajuste_pagamento_payload?.valor_original || vinc.valor) }}
                    </span>

                    <small
                      v-if="Number(vinc.ajuste_pagamento_payload?.desconto || 0) > 0"
                      class="text-muted d-block mt-1"
                    >
                      Desconto: {{ formatCurrency(vinc.ajuste_pagamento_payload?.desconto) }}
                    </small>

                    <small
                      v-if="Number(vinc.ajuste_pagamento_payload?.juros || 0) > 0"
                      class="text-muted d-block mt-1"
                    >
                      Juros: {{ formatCurrency(vinc.ajuste_pagamento_payload?.juros) }}
                    </small>

                    <small
                      v-if="Number(vinc.ajuste_pagamento_payload?.multa || 0) > 0"
                      class="text-muted d-block mt-1"
                    >
                      Multa: {{ formatCurrency(vinc.ajuste_pagamento_payload?.multa) }}
                    </small>
                  </template>

                  <template v-else>
                    {{ formatCurrency(vinc.valor_utilizado || vinc.valor) }}
                  </template>
                </div>
              </div>

              <div class="mt-2">
                <span
                  class="status-badge me-1"
                  :class="
                    String(vinc.tipo_vinculo || '').includes('ABATE')
                      ? 'is-amber'
                      : 'is-blue'
                  "
                >
                  {{ formatarPapelConciliacaoComposta(vinc.tipo_vinculo) }}
                </span>

                <span
                  v-if="vinc.ajuste_pagamento_conciliacao"
                  class="status-badge is-orange me-1"
                >
                  Pagamento ajustado
                </span>                

                <span
                  v-if="vinc.receita_abatimento_criada_conciliacao"
                  class="status-badge is-green me-1"
                >
                  Receita de abatimento criada
                </span>

              </div>

              <div
                v-if="vinc.observacao_conciliacao"
                class="composta-detalhe-observacao mt-2"
              >
                <strong>Observação:</strong>
                {{ vinc.observacao_conciliacao }}
              </div>
            </div>
          </div>
        </div>        

        <div v-if="avisoTolerancia" class="alert alert-info py-2 mb-3">
          Diferença dentro da tolerância de arredondamento de até R$ 0,10. A conciliação pode ser confirmada.
        </div>

        <div v-if="aviso" class="alert alert-warning py-2 mb-3">
          {{ aviso }}
        </div>


        <div
          v-if="temMultiplasCombinacoesCheque && !isVisualizacao"
          class="alert alert-warning py-2 mb-3"
        >
          <strong>Múltiplas composições possíveis.</strong>
          <div>
            Foram encontradas
            <strong v-if="quantidadeCombinacoesCheque">{{ quantidadeCombinacoesCheque }}</strong>
            combinações de cheques que fecham o valor do depósito.
          </div>
          <div>
            Nenhum lote foi selecionado automaticamente. Revise os números dos cheques e os eventos bancários posteriores antes de confirmar.
          </div>
        </div>

        <div
          v-else-if="composicaoChequeConfiavel && temDepositoChequeAgrupado && !isVisualizacao"
          class="alert alert-info py-2 mb-3"
        >
          <strong>Composição sugerida com evidência bancária.</strong>
          <div>
            A sugestão considera o valor do depósito, os cheques físicos e os eventos posteriores de devolução ou reapresentação.
          </div>
          <div>Revise os itens antes de confirmar.</div>
        </div>

        <div v-if="erro" class="alert alert-danger py-2 mb-3">
          {{ erro }}
        </div>

        <div
          v-if="mostrarAvisoPixPessoaIdentificadaPendencia"
          class="alert alert-info py-2 mb-3 pix-pessoa-identificada-alert"
        >
          <strong>{{ tituloAvisoPixPessoaIdentificada }}</strong>

          <div class="white-space-pre-line">
            {{ textoAvisoPixPessoaIdentificada }}
          </div>

          <div class="mt-1">
            Selecione manualmente o lançamento correto para concluir a conciliação.
          </div>
        </div>        

        <div
          v-if="mostrarAvisoPixSemPessoa"
          class="alert alert-warning py-2 mb-3 pix-sem-pessoa-alert"
        >
          <strong>PIX sem pessoa identificada.</strong>
          <div>
            O identificador <strong>{{ identificadorPixMemo }}</strong> não foi encontrado em CPF, celular ou telefone.
          </div>
          <div>
            Foram encontrados lançamentos compatíveis por data, valor e forma de pagamento, mas o sistema não tem segurança para escolher automaticamente.
            Selecione manualmente o lançamento correto.
          </div>
        </div>        

        <div
          v-if="podeCriarReceitaConciliar && !mostrarFormCriarReceita"
          class="alert alert-info py-2 mb-3"
        >
          <strong>Nenhum lançamento foi encontrado para este item bancário.</strong>
          <div>
            Você pode criar uma Receita Geral com os dados do banco e conciliá-la em seguida.
          </div>
        </div>

        <div
          v-if="podeCriarDespesaConciliar && !mostrarFormCriarDespesa"
          class="alert alert-warning py-2 mb-3"
        >
          <strong>Nenhum lançamento foi encontrado para este débito bancário.</strong>
          <div>
            Você pode criar uma Despesa com os dados do banco e conciliá-la em seguida.
          </div>
        </div>

        <div
          v-if="podeMostrarConciliacaoComposta && !mostrarConciliacaoComposta"
          class="info-box conciliacao-composta-start-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center gap-2">
            <div>
              <strong>Nenhum lançamento correspondente foi encontrado.</strong>
              <div class="text-muted">
                Este item pode representar um acerto consolidado. Você pode consultar receitas e despesas ainda não conciliadas para montar a composição manualmente.
              </div>
            </div>

            <button
              type="button"
              class="btn btn-outline-primary modal-action-btn"
              :disabled="carregandoComposta"
              @click="carregarCandidatosConciliacaoComposta"
            >
              {{ carregandoComposta ? 'Carregando...' : 'Mostrar possíveis candidatos' }}
            </button>
          </div>
        </div>

        <div
          v-if="podeMostrarConciliacaoComposta && mostrarConciliacaoComposta"
          class="info-box conciliacao-composta-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <strong>Conciliação composta</strong>
              <div class="text-muted">
                Candidatos ainda não conciliados no período. Nesta etapa, a lista é apenas informativa.
              </div>
            </div>

            <span class="status-badge is-blue">
              {{ totalCandidatosComposta }} candidato(s)
            </span>
          </div>

          <div v-if="erroComposta" class="alert alert-danger py-2 mb-3">
            {{ erroComposta }}
          </div>

          <div v-if="carregandoComposta" class="text-muted py-2">
            Carregando candidatos da conciliação composta...
          </div>

          <template v-else>
            <div class="composta-section mb-3">
              <div class="composta-section-title">
                Receitas disponíveis
              </div>

              <div class="table-scroll composta-table-scroll">
                <div class="table-responsive">
                  <table class="table table-striped table-hover mb-0">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Data</th>
                        <th>Origem</th>
                        <th class="text-end">Valor</th>
                        <th>Forma</th>
                        <th>Conta</th>
                        <th>Autorização</th>
                        <th>Score</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-if="!candidatosCompostaReceitas.length">
                        <td colspan="8" class="text-center text-muted py-3">
                          Nenhuma receita disponível encontrada.
                        </td>
                      </tr>

                      <tr
                        v-for="cand in candidatosCompostaReceitas"
                        :key="`receita-${cand.origem_tabela}-${cand.origem_id}`"
                        :class="{ 'row-selected': isReceitaCompostaSelecionada(cand) }"
                      >
                        <td>
                          <input
                            type="checkbox"
                            :checked="isReceitaCompostaSelecionada(cand)"
                            @change="toggleReceitaComposta(cand)"
                          />
                        </td>

                        <td>{{ formatDate(getDataConsideradaConciliacao(cand)) }}</td>
                        <td>
                          <div class="candidate-title">
                            {{ cand.descricao || cand.origem_tabela }}
                          </div>
                          <small class="text-muted">
                            {{ cand.origem_tabela }} #{{ cand.origem_id }}
                          </small>
                        </td>
                        <td class="text-end">{{ formatCurrency(cand.valor) }}</td>
                        <td>{{ cand.forma_pagamento_nome || '—' }}</td>
                        <td>{{ cand.conta_financeira_nome || cand.conta_financeira_id || '—' }}</td>
                        <td>{{ cand.numero_autorizacao || '—' }}</td>
                        <td>{{ cand.score ?? '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="composta-section">
              <div class="composta-section-title">
                Despesas disponíveis
              </div>

              <div class="table-scroll composta-table-scroll">
                <div class="table-responsive">
                  <table class="table table-striped table-hover mb-0">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Data</th>
                        <th>Origem</th>
                        <th class="text-end">Valor</th>
                        <th>Forma</th>
                        <th>Conta</th>
                        <th>Autorização</th>
                        <th>Score</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-if="!candidatosCompostaDespesas.length">
                        <td colspan="8" class="text-center text-muted py-3">
                          Nenhuma despesa disponível encontrada.
                        </td>
                      </tr>

                      <tr
                        v-for="cand in candidatosCompostaDespesas"
                        :key="`despesa-${cand.origem_tabela}-${cand.origem_id}`"
                        :class="{ 'row-selected': isDespesaCompostaSelecionada(cand) }"
                      >
                        <td>
                          <input
                            type="checkbox"
                            :checked="isDespesaCompostaSelecionada(cand)"
                            @change="toggleDespesaComposta(cand)"
                          />
                        </td>

                        <td>{{ formatDate(cand.dt_caixa) }}</td>
                        <td>
                          <div class="candidate-title">
                            {{ cand.descricao || cand.origem_tabela }}
                          </div>
                          <small class="text-muted">
                            {{ cand.origem_tabela }} #{{ cand.origem_id }}
                          </small>
                        </td>
                        <td class="text-end">{{ formatCurrency(cand.valor) }}</td>
                        <td>{{ cand.forma_pagamento_nome || '—' }}</td>
                        <td>{{ cand.conta_financeira_nome || cand.conta_financeira_id || '—' }}</td>
                        <td>{{ cand.numero_autorizacao || '—' }}</td>
                        <td>{{ cand.score ?? '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="composta-resumo mt-3">
              <div class="composta-resumo-card">
                <span>Total receitas selecionadas</span>
                <strong>{{ formatCurrency(totalReceitasComposta) }}</strong>
              </div>

              <div class="composta-resumo-card">
                <span>Total despesas selecionadas</span>
                <strong>{{ formatCurrency(totalDespesasComposta) }}</strong>
              </div>

              <div class="composta-resumo-card">
                <span>
                  Saldo líquido
                  <small v-if="isOfxDebito" class="d-block text-muted">
                    despesas - receitas
                  </small>
                  <small v-else-if="isOfxCredito" class="d-block text-muted">
                    receitas - despesas
                  </small>
                </span>
                <strong>{{ formatCurrency(saldoLiquidoComposta) }}</strong>
              </div>

              <div class="composta-resumo-card">
                <span>Valor banco</span>
                <strong>{{ formatCurrency(valorItem) }}</strong>
              </div>

              <div
                class="composta-resumo-card"
                :class="podeRevisarConciliacaoComposta ? 'composta-resumo-card--ok' : 'composta-resumo-card--alert'"
              >
                <span>Diferença</span>
                <strong>{{ formatCurrency(diferencaComposta) }}</strong>
                <small>{{ mensagemDiferencaComposta }}</small>
              </div>
            </div>

            <div
              v-if="mostrarTratamentoDiferencaComposta"
              class="info-box tratar-diferenca-composta-box mt-3"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>A composição não fecha com o valor do banco.</strong>
                  <div class="text-muted">
                    Como deseja tratar a diferença de {{ formatCurrency(diferencaAbsComposta) }}?
                  </div>
                </div>

                <span class="status-badge is-orange">
                  Diferença
                </span>
              </div>

              <div class="text-muted mb-2">
                {{ textoTratamentoDiferencaComposta }}
              </div>

              <div class="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn btn-outline-warning modal-action-btn"
                  @click="escolherCorrigirValorLancamento"
                >
                  Ajustar pagamento
                </button>

                <button
                  type="button"
                  class="btn btn-outline-primary modal-action-btn"
                  @click="escolherLancamentoAbatimento"
                >
                  Criar/selecionar lançamento de abatimento
                </button>
              </div>

              <div
                v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO'"
                class="alert alert-warning py-2 mt-3 mb-0"
              >
                Use esta opção quando o valor efetivamente pago for diferente por juros, multa ou desconto.
                O valor original do lançamento será preservado, e o valor líquido será usado para fechar a conciliação.
              </div>

              <div
                v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO'"
                class="info-box ajuste-pagamento-composta-box mt-3"
              >
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <strong>Ajustar pagamento</strong>
                    <div class="text-muted">
                      Informe juros, multa ou desconto para calcular o valor líquido usado na conciliação.
                    </div>
                  </div>

                  <span class="status-badge is-orange">
                    Ajuste financeiro
                  </span>
                </div>

                <div class="table-scroll composta-table-scroll">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Despesa</th>
                          <th class="text-end">Valor original</th>
                          <th class="text-end">Juros</th>
                          <th class="text-end">Multa</th>
                          <th class="text-end">Desconto</th>
                          <th class="text-end">Valor líquido</th>
                          <th>Observação</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="item in despesasSelecionadasComposta"
                          :key="`ajuste-pagamento-${item.origem_tabela}-${item.origem_id}`"
                        >
                          <td>
                            <div class="candidate-title">
                              {{ item.descricao || item.origem_tabela }}
                            </div>
                            <small class="text-muted">
                              {{ item.origem_tabela }} #{{ item.origem_id }}
                            </small>
                          </td>

                          <td class="text-end">
                            {{ formatCurrency(getValorOriginalComposta(item)) }}
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).juros"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'juros', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'juros')"
                            />
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).multa"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'multa', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'multa')"
                            />
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).desconto"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'desconto', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'desconto')"
                            />
                          </td>

                          <td class="text-end">
                            <strong
                              :class="getValorLiquidoPagamentoComposta(item) > 0 ? 'diff-ok' : 'diff-alert'"
                            >
                              {{ formatCurrency(getValorLiquidoPagamentoComposta(item)) }}
                            </strong>
                          </td>

                          <td>
                            <input
                              :value="getAjustePagamento(item).observacao"
                              type="text"
                              class="form-control"
                              placeholder="Opcional"
                              @input="setAjustePagamentoCampo(item, 'observacao', $event.target.value)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="composta-resumo mt-3">
                  <div class="composta-resumo-card">
                    <span>Total despesas líquidas</span>
                    <strong>{{ formatCurrency(totalDespesasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Total receitas abatendo</span>
                    <strong>{{ formatCurrency(totalReceitasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Saldo líquido</span>
                    <strong>{{ formatCurrency(saldoLiquidoComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Valor banco</span>
                    <strong>{{ formatCurrency(valorItem) }}</strong>
                  </div>

                  <div
                    class="composta-resumo-card"
                    :class="podeRevisarConciliacaoComposta ? 'composta-resumo-card--ok' : 'composta-resumo-card--alert'"
                  >
                    <span>Diferença</span>
                    <strong>{{ formatCurrency(diferencaComposta) }}</strong>
                    <small>{{ mensagemDiferencaComposta }}</small>
                  </div>
                </div>

                <div class="text-muted mt-2">
                  Nesta etapa, o ajuste ainda é apenas calculado no modal. Na próxima etapa, salvaremos juros, multa e desconto no backend antes de confirmar a conciliação.
                </div>
              </div>              

              <div
                v-if="tratamentoDiferencaComposta === 'ABATIMENTO'"
                class="alert alert-info py-2 mt-3 mb-0"
              >
                Use esta opção quando a diferença representar uma compensação real.
                Selecione uma receita/despesa existente que abata a composição ou, na próxima etapa, crie um novo lançamento de abatimento.
              </div>
            </div>

            <div class="d-flex justify-content-end mt-3 gap-2">
              <button
                type="button"
                class="btn btn-primary modal-action-btn"
                :disabled="!podeConfirmarComposicaoOuAjuste"
                @click="abrirRevisaoConciliacaoComposta"
              >
                Revisar conciliação composta
              </button>
            </div>
          </template>
        </div>        

        <div
          v-if="podeCriarReceitaConciliar && mostrarFormCriarReceita"
          class="info-box criar-receita-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Criar Receita Geral e Conciliar</strong>
            <span class="status-badge is-blue">Novo lançamento</span>
          </div>

          <div class="row g-2">
            <div class="col-md-8">
              <label class="form-label">Descrição da receita</label>
              <input
                v-model="novaReceita.descricao"
                type="text"
                class="form-control"
                placeholder="Ex.: ISABELLA COSTA REIS - MATR 138"
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Subconta</label>
              <select
                v-model="novaReceita.subconta_id"
                class="form-control"
                :disabled="carregandoSubcontas"
              >
                <option value="">
                  {{ carregandoSubcontas ? 'Carregando...' : 'Selecione a subconta' }}
                </option>

                <option
                  v-for="subconta in subcontasReceita"
                  :key="subconta.id"
                  :value="subconta.id"
                >
                  {{ subconta.nome }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Valor</label>
              <input
                :value="formatCurrency(valorItem)"
                type="text"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Pagamento/Recebimento</label>
              <input
                :value="formatDate(props.item?.dt_movimento)"
                type="text"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Forma</label>
              <input
                value="Sugerida automaticamente pelo histórico bancário"
                type="text"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-12">
              <label class="form-label">Observação</label>
              <textarea
                v-model="novaReceita.observacao"
                class="form-control"
                rows="2"
                placeholder="Observação opcional"
              ></textarea>
            </div>
          </div>

          <div class="mt-2 text-muted">
            A receita será criada com a mesma data, valor, conta financeira e forma de pagamento do item bancário.
          </div>
        </div>     
        
        <div
          v-if="podeCriarReceitaConciliar && mostrarConfirmacaoCriarReceita"
          class="info-box confirmar-criacao-receita-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Confirmar criação da receita e conciliação</strong>
            <span class="status-badge is-green">Confirmação</span>
          </div>

          <div class="confirmacao-receita-grid">
            <div>
              <span class="confirmacao-label">Valor</span>
              <strong>{{ formatCurrency(valorItem) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Pagamento/Recebimento</span>
              <strong>{{ formatDate(props.item?.dt_movimento) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Forma</span>
              <strong>Sugerida pelo banco</strong>
            </div>

            <div>
              <span class="confirmacao-label">Subconta</span>
              <strong>{{ subcontaSelecionadaCriacao?.nome || '—' }}</strong>
            </div>
          </div>

          <div class="confirmacao-descricao mt-2">
            <span class="confirmacao-label">Descrição</span>
            <strong>{{ novaReceita.descricao || '—' }}</strong>
          </div>

          <div
            v-if="novaReceita.observacao"
            class="confirmacao-descricao mt-2"
          >
            <span class="confirmacao-label">Observação</span>
            <span>{{ novaReceita.observacao }}</span>
          </div>

          <div class="text-muted mt-2">
            Essa ação criará o lançamento financeiro e conciliará o item bancário.
          </div>
        </div>      

        <div
          v-if="podeCriarDespesaConciliar && mostrarConfirmacaoCriarDespesa"
          class="info-box confirmar-criacao-despesa-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Confirmar criação da despesa e conciliação</strong>
            <span class="status-badge is-orange">Confirmação</span>
          </div>

          <div class="confirmacao-receita-grid">
            <div>
              <span class="confirmacao-label">Valor</span>
              <strong>{{ formatCurrency(valorItem) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Pagamento</span>
              <strong>{{ formatDate(props.item?.dt_movimento) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Forma</span>
              <strong>{{ formaSelecionadaDespesa?.nome || '—' }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Subconta</span>
              <strong>{{ subcontaSelecionadaDespesa?.nome || '—' }}</strong>
            </div>
          </div>

          <div class="confirmacao-descricao mt-2">
            <span class="confirmacao-label">Descrição</span>
            <strong>{{ novaDespesa.descricao || '—' }}</strong>
          </div>

          <div
            v-if="novaDespesa.observacao"
            class="confirmacao-descricao mt-2"
          >
            <span class="confirmacao-label">Observação</span>
            <span>{{ novaDespesa.observacao }}</span>
          </div>

          <div class="text-muted mt-2">
            Essa ação criará a despesa financeira e conciliará o item bancário.
          </div>
        </div>        
        
        <div
          v-if="podeCriarDespesaConciliar && mostrarFormCriarDespesa"
          class="info-box criar-despesa-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Criar Despesa e Conciliar</strong>
            <span class="status-badge is-orange">Novo lançamento</span>
          </div>

          <div class="row g-2">
            <div class="col-md-8">
              <label class="form-label">Descrição da despesa</label>
              <input
                v-model="novaDespesa.descricao"
                type="text"
                class="form-control"
                placeholder="Ex.: Tarifa bancária"
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Subconta</label>
              <select
                v-model="novaDespesa.subconta_id"
                class="form-control"
                :disabled="carregandoDespesaListas"
              >
                <option value="">
                  {{ carregandoDespesaListas ? 'Carregando...' : 'Selecione a subconta' }}
                </option>

                <option
                  v-for="subconta in subcontasDespesa"
                  :key="subconta.id"
                  :value="subconta.id"
                >
                  {{ subconta.nome }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Valor</label>
              <input
                :value="formatCurrency(valorItem)"
                type="text"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Pagamento</label>
              <input
                :value="formatDate(props.item?.dt_movimento)"
                type="text"
                class="form-control"
                disabled
              />
            </div>

            <div class="col-md-4">
              <label class="form-label">Forma de pagamento</label>
              <select
                v-model="novaDespesa.forma_pagamento_id"
                class="form-control"
                :disabled="carregandoDespesaListas"
              >
                <option value="">
                  {{ carregandoDespesaListas ? 'Carregando...' : 'Selecione a forma' }}
                </option>

                <option
                  v-for="forma in formasPagamentoDespesa"
                  :key="forma.id"
                  :value="forma.id"
                >
                  {{ forma.nome }}
                </option>
              </select>
            </div>

            <div class="col-12">
              <label class="form-label">Observação</label>
              <textarea
                v-model="novaDespesa.observacao"
                class="form-control"
                rows="2"
                placeholder="Observação opcional"
              ></textarea>
            </div>
          </div>

          <div class="mt-2 text-muted">
            A despesa será criada com a mesma data, valor e conta financeira do item bancário.
          </div>
        </div>        

        <div
          v-if="candidatoComAjusteSelecionado && mostrarConfirmacaoAjustePix"
          class="info-box confirmar-ajuste-pix-box mb-3"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Confirmar ajuste e conciliação PIX</strong>
            <span class="status-badge is-orange">Ajuste necessário</span>
          </div>

          <div class="confirmacao-receita-grid">
            <div>
              <span class="confirmacao-label">Valor ajustado</span>
              <strong>{{ formatCurrency(valorItem) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Forma</span>
              <strong>PIX</strong>
            </div>

            <div>
              <span class="confirmacao-label">Pagamento</span>
              <strong>{{ formatDate(props.item?.dt_movimento) }}</strong>
            </div>

            <div>
              <span class="confirmacao-label">Recebimento</span>
              <strong>{{ formatDate(props.item?.dt_movimento) }}</strong>
            </div>
          </div>

          <div class="confirmacao-descricao mt-2">
            <span class="confirmacao-label">Lançamento selecionado</span>
            <strong>
              {{ candidatoComAjusteSelecionado.descricao || candidatoComAjusteSelecionado.origem_tabela }}
            </strong>
          </div>

          <div
            v-if="candidatoComAjusteSelecionado.pix_pessoa_nome || candidatoComAjusteSelecionado.pix_identificador"
            class="confirmacao-descricao mt-2"
          >
            <span class="confirmacao-label">PIX identificado</span>
            <span>
              {{ candidatoComAjusteSelecionado.pix_pessoa_nome || 'Pessoa não informada' }}
              <span v-if="candidatoComAjusteSelecionado.pix_match_campo">
                · {{ candidatoComAjusteSelecionado.pix_match_campo }}
              </span>
              <span v-if="candidatoComAjusteSelecionado.pix_identificador">
                · {{ candidatoComAjusteSelecionado.pix_identificador }}
              </span>
            </span>
          </div>

          <div
            v-if="observacao"
            class="confirmacao-descricao mt-2"
          >
            <span class="confirmacao-label">Observação</span>
            <span>{{ observacao }}</span>
          </div>

          <div class="text-muted mt-2">
            Essa ação atualizará o lançamento financeiro selecionado e criará a conciliação.
          </div>
        </div>        

        <template
          v-if="
            (etapa === 'selecao' || isVisualizacao) &&
            !mostrarFormCriarReceita &&
            !mostrarFormCriarDespesa &&
            !mostrarConfirmacaoAjustePix
          "
        >
          <div v-if="loading" class="text-muted py-3">
            Carregando candidatos...
          </div>

          <div
            v-else-if="!temConciliacaoCompostaDetalhe"
            class="mb-3"
          >
            <div class="section-header mb-2">
              <div>
                <strong>{{ isVisualizacao ? 'Lançamentos vinculados' : 'Candidatos encontrados' }}</strong>
                <small class="text-muted d-block">
                  {{ isVisualizacao ? 'Movimentos já vinculados a este item.' : 'Selecione um ou mais lançamentos para compor o valor do item.' }}
                </small>
              </div>

              <span v-if="!isVisualizacao" class="selection-counter">
                {{ selecionados.length }} selecionado(s)
              </span>
            </div>

            <div class="table-scroll">
              <div class="table-responsive">
                <table class="table table-striped table-hover mb-0">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Data</th>
                      <th>Origem</th>
                      <th class="text-end">Valor considerado</th>
                      <th>Forma</th>
                      <th>Cheque</th>
                      <th>Tipo vínculo</th>
                      <th>Autorização</th>
                      <th>Score</th>
                      <th>Saldo disp.</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="!candidatos.length">
                      <td colspan="10" class="text-center text-muted py-4">
                        Nenhum candidato encontrado.
                      </td>
                    </tr>

                    <tr
                      v-for="cand in candidatos"
                      :key="`${cand.origem_tabela}-${cand.origem_id}`"
                      :class="{ 'row-selected': isSelecionado(cand) }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          :checked="isSelecionado(cand)"
                          :disabled="isVisualizacao || salvando"
                          @change="toggleSelecionado(cand)"
                        />
                      </td>

                      <td>{{ formatDate(cand.dt_caixa) }}</td>

                      <td>
                        <div class="candidate-title">
                          {{ cand.descricao || cand.origem_tabela }}
                        </div>

                        <div
                          v-if="isPixPessoaIdentificada(cand)"
                          class="pix-match-box mt-1"
                        >
                          <div class="pix-match-title">
                            <i class="bi bi-person-check"></i>
                            Pessoa identificada pelo PIX
                          </div>

                          <div class="pix-match-text">
                            {{ cand.pix_pessoa_nome || 'Pessoa não informada' }}
                            <span v-if="cand.pix_match_campo">
                              · {{ cand.pix_match_campo }}
                            </span>
                            <span v-if="cand.pix_identificador">
                              · {{ cand.pix_identificador }}
                            </span>
                          </div>

                          <div
                            v-if="temAlunosPixVinculados(cand)"
                            class="pix-alunos-vinculados mt-2"
                          >
                            <div class="pix-alunos-title">
                              Aluno(s) vinculado(s):
                            </div>

                            <ul class="pix-alunos-list">
                              <li
                                v-for="aluno in getAlunosPixVinculados(cand)"
                                :key="`${aluno.tipo_vinculo || 'vinculo'}-${aluno.matricula_id}`"
                              >
                                {{ aluno.aluno_nome }}
                                <span v-if="aluno.matricula_id">
                                  — Matrícula #{{ aluno.matricula_id }}
                                </span>
                              </li>
                            </ul>
                          </div>                          

                          <div
                            v-if="cand.ajuste_necessario"
                            class="pix-adjust-warning mt-1"
                          >
                            Ajuste necessário antes de conciliar.
                          </div>

                          <div
                            v-if="temDivergencias(cand)"
                            class="pix-divergences mt-1"
                          >
                            <span
                              v-for="div in listarDivergencias(cand)"
                              :key="div"
                              class="divergence-badge"
                            >
                              {{ div }}
                            </span>
                          </div>
                        </div>

                        <small
                          v-if="isChequeReapresentado(cand)"
                          class="text-warning d-block"
                        >
                          Reapresentação de cheque conciliada com a receita original.
                        </small>

                        <small
                          v-if="String(cand.origem_tabela || '') === 'despesas_pagamentos'"
                          class="text-muted d-block"
                        >
                          Valor efetivamente pago da despesa.
                        </small>

                        <small
                          v-if="cand.candidato_agrupado_pix"
                          class="text-primary d-block"
                        >
                          Candidato para PIX agrupado.
                        </small>

                        <small
                          v-if="cand.candidato_agrupado_cheque"
                          class="text-primary d-block"
                        >
                          Candidato para cheque agrupado.
                        </small>

                        <small
                          v-if="isOperadoraAutorizacaoAgrupada(cand)"
                          class="text-primary d-block"
                        >
                          Parte de uma autorização agrupada. Os lançamentos do grupo são selecionados em conjunto.
                        </small>


                        <small
                          v-if="chequeFisicoPossuiMaisDeUmLancamento(cand)"
                          class="text-primary d-block"
                        >
                          Mesmo cheque físico em {{ candidatosDoMesmoChequeFisico(cand).length }} lançamentos. A seleção será feita em conjunto.
                        </small>

                        <div v-if="cand.cheque_evento_posterior" class="cheque-evento-posterior mt-1">
                          <div class="cheque-evento-posterior__title">
                            <i class="bi bi-bank"></i>
                            Evento bancário posterior
                          </div>
                          <div>
                            {{ formatDate(cand.cheque_evento_posterior.dt_movimento) }} ·
                            {{ cand.cheque_evento_posterior.memo || 'Movimento de cheque' }} ·
                            {{ formatCurrency(cand.cheque_evento_posterior.valor_abs || cand.cheque_evento_posterior.valor) }}
                          </div>
                        </div>

                        <div
                          v-if="isPrimeiroCandidatoDoCheque(cand) && Array.isArray(cand.deposito_cheque_motivos) && cand.deposito_cheque_motivos.length"
                          class="cheque-combinacao-motivos mt-1"
                        >
                          <div class="cheque-combinacao-motivos__title">Motivos da sugestão</div>
                          <ul>
                            <li v-for="motivo in cand.deposito_cheque_motivos" :key="motivo">{{ motivo }}</li>
                          </ul>
                        </div>

                        <small
                          v-if="isConsolidadoParcial(cand)"
                          class="text-warning d-block"
                        >
                          Lançamento maior disponível para vínculo parcial.
                        </small>

                        <small
                          v-if="isConsolidadoParcial(cand)"
                          class="text-muted d-block"
                        >
                          Valor original: {{ formatCurrency(cand.valor) }}
                        </small>

                        <small
                          v-if="isConsolidadoParcial(cand) && cand.pix_pessoa_nome"
                          class="text-primary d-block"
                        >
                          Pessoa identificada: {{ cand.pix_pessoa_nome }}
                        </small>
                      </td>

                      <td class="text-end">
                        <strong v-if="isConsolidadoParcial(cand)">
                          {{ formatCurrency(getValorConsideradoConciliacao(cand)) }}
                        </strong>

                        <template v-else>
                          {{ formatCurrency(getValorConsideradoConciliacao(cand)) }}
                        </template>

                        <small
                          v-if="isConsolidadoParcial(cand)"
                          class="text-muted d-block"
                        >
                          de {{ formatCurrency(cand.valor) }}
                        </small>
                      </td>

                      <td>{{ cand.forma_pagamento_nome || '—' }}</td>

                      <td>
                        <div><strong>{{ cand.cheque_numero || cand.cheque_evento_cheque_numero || '—' }}</strong></div>

                        <small
                          v-if="chequeFisicoPossuiMaisDeUmLancamento(cand)"
                          class="text-primary d-block"
                        >
                          Grupo físico:
                          {{ formatCurrency(candidatosDoMesmoChequeFisico(cand).reduce((acc, item) => acc + Math.abs(Number(getValorConsideradoConciliacao(item) || 0)), 0)) }}
                        </small>

                        <small
                          v-if="cand.cheque_numero_confere === true"
                          class="text-success d-block"
                        >
                          Número confere com o banco.
                        </small>

                        <small
                          v-else-if="cand.cheque_numero_alerta"
                          class="text-warning d-block"
                        >
                          {{ cand.cheque_numero_alerta }}
                          <span v-if="cand.cheque_numero_banco">
                            OFX: {{ cand.cheque_numero_banco }}
                          </span>
                        </small>
                      </td>

                      <td>
                        <span
                          v-if="isChequeDevolvido(cand)"
                          class="status-badge is-red"
                        >
                          Cheque devolvido
                        </span>

                        <span
                          v-else-if="isChequeReapresentado(cand)"
                          class="status-badge is-amber"
                        >
                          Cheque reapresentado
                        </span>

                        <span
                          v-else-if="isDepositoChequeAgrupado(cand)"
                          class="status-badge is-blue"
                        >
                          Depósito agrupado
                        </span>

                        <span
                          v-else-if="isPixAjusteNecessario(cand)"
                          class="status-badge is-orange"
                        >
                          Ajuste necessário
                        </span>

                        <span
                          v-else-if="isPixPessoaIdentificada(cand)"
                          class="status-badge is-blue"
                        >
                          PIX identificado
                        </span>

                        <span
                          v-else-if="isOperadoraAutorizacaoAgrupada(cand)"
                          class="status-badge is-blue"
                        >
                          Autorização agrupada
                        </span>

                        <span
                          v-else-if="isConsolidadoParcial(cand)"
                          class="status-badge is-amber"
                        >
                          Consolidado parcial
                        </span>

                        <span v-else class="status-badge is-gray">
                          Normal
                        </span>
                      </td>

                      <td>{{ cand.numero_autorizacao || '—' }}</td>
                      <td>{{ cand.score ?? '—' }}</td>

                      <td>
                        {{ cand.saldo_disponivel != null ? formatCurrency(cand.saldo_disponivel) : '—' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            v-if="isPagamentoConsolidadoBanco"
            class="info-box ajuste-valor-composta-box mb-3"
          >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <strong>Pagamento consolidado</strong>
                <div class="text-muted">
                  Selecione os lançamentos que compõem o pagamento. Se a composição não fechar, trate a diferença como correção do lançamento ou como abatimento financeiro real.
                </div>
              </div>

              <span class="status-badge is-blue">
                {{ selecionados.length }} selecionado(s)
              </span>
            </div>

            <div
              v-if="
                selecionados.length &&
                (
                  !podeConfirmarComposicaoOuAjuste ||
                  tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO' ||
                  tratamentoDiferencaComposta === 'ABATIMENTO'
                )
              "
              class="info-box tratar-diferenca-composta-box mt-3"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>
                    {{ podeConfirmarComposicaoOuAjuste ? 'Composição ajustada com o valor do banco.' : 'A composição não fecha com o valor do banco.' }}
                  </strong>

                  <div class="text-muted">
                    {{ podeConfirmarComposicaoOuAjuste ? 'Revise os ajustes antes de confirmar.' : 'Como deseja tratar a diferença?' }}
                  </div>
                </div>

                <span class="status-badge is-orange">
                  Diferença
                </span>
              </div>

              <div class="text-muted mb-2">
                Para pagamento consolidado, a diferença não deve ser tratada apenas como valor utilizado.
                Ela deve virar correção real do lançamento ou abatimento financeiro.
              </div>

              <div class="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn btn-outline-warning modal-action-btn"
                  @click="escolherCorrigirValorLancamento"
                >
                  Ajustar pagamento
                </button>

                <button
                  type="button"
                  class="btn btn-outline-primary modal-action-btn"
                  @click="escolherLancamentoAbatimento"
                >
                  Criar/selecionar lançamento de abatimento
                </button>
              </div>

              <div
                v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO'"
                class="alert alert-warning py-2 mt-3 mb-0"
              >
                Use esta opção quando o valor efetivamente pago for diferente por juros, multa ou desconto.
                O valor original do lançamento será preservado, e o valor líquido será usado para fechar a conciliação.
              </div>

              <div
                v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO'"
                class="info-box ajuste-pagamento-composta-box mt-3"
              >
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <strong>Ajustar pagamento</strong>
                    <div class="text-muted">
                      Informe juros, multa ou desconto para calcular o valor líquido usado na conciliação.
                    </div>
                  </div>

                  <span class="status-badge is-orange">
                    Ajuste financeiro
                  </span>
                </div>

                <div class="table-scroll composta-table-scroll">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Despesa</th>
                          <th class="text-end">Valor original</th>
                          <th class="text-end">Juros</th>
                          <th class="text-end">Multa</th>
                          <th class="text-end">Desconto</th>
                          <th class="text-end">Valor líquido</th>
                          <th>Observação</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="item in despesasSelecionadasComposta"
                          :key="`ajuste-pagamento-consolidado-${item.origem_tabela}-${item.origem_id}`"
                        >
                          <td>
                            <div class="candidate-title">
                              {{ item.descricao || item.origem_tabela }}
                            </div>
                            <small class="text-muted">
                              {{ item.origem_tabela }} #{{ item.origem_id }}
                            </small>
                          </td>

                          <td class="text-end">
                            {{ formatCurrency(getValorOriginalComposta(item)) }}
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).juros"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'juros', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'juros')"
                            />
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).multa"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'multa', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'multa')"
                            />
                          </td>

                          <td class="text-end">
                            <input
                              :value="getAjustePagamento(item).desconto"
                              type="text"
                              inputmode="decimal"
                              class="form-control text-end"
                              @input="setAjustePagamentoCampo(item, 'desconto', $event.target.value)"
                              @blur="onBlurAjustePagamentoCampo(item, 'desconto')"
                            />
                          </td>

                          <td class="text-end">
                            <strong
                              :class="getValorLiquidoPagamentoComposta(item) > 0 ? 'diff-ok' : 'diff-alert'"
                            >
                              {{ formatCurrency(getValorLiquidoPagamentoComposta(item)) }}
                            </strong>
                          </td>

                          <td>
                            <input
                              :value="getAjustePagamento(item).observacao"
                              type="text"
                              class="form-control"
                              placeholder="Opcional"
                              @input="setAjustePagamentoCampo(item, 'observacao', $event.target.value)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="composta-resumo mt-3">
                  <div class="composta-resumo-card">
                    <span>Total despesas líquidas</span>
                    <strong>{{ formatCurrency(totalDespesasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Total receitas abatendo</span>
                    <strong>{{ formatCurrency(totalReceitasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Saldo líquido</span>
                    <strong>{{ formatCurrency(saldoLiquidoComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Valor banco</span>
                    <strong>{{ formatCurrency(valorItem) }}</strong>
                  </div>

                  <div
                    class="composta-resumo-card"
                    :class="podeRevisarConciliacaoComposta ? 'composta-resumo-card--ok' : 'composta-resumo-card--alert'"
                  >
                    <span>Diferença</span>
                    <strong>{{ formatCurrency(diferencaComposta) }}</strong>
                    <small>{{ mensagemDiferencaComposta }}</small>
                  </div>
                </div>

                <div class="text-muted mt-2">
                  Nesta etapa, o ajuste ainda é apenas calculado no modal. Na próxima etapa, salvaremos juros, multa e desconto no backend antes de confirmar a conciliação.
                </div>
              </div>              

              <div
                v-if="tratamentoDiferencaComposta === 'ABATIMENTO'"
                class="alert alert-info py-2 mt-3 mb-0"
              >
                Use esta opção quando a diferença representar uma compensação real.
                Se não existir uma receita já cadastrada para abater o pagamento, crie uma Receita Geral de abatimento.
              </div>

              <div
                v-if="podeCriarReceitaAbatimento"
                class="d-flex justify-content-end mt-3"
              >
                <button
                  type="button"
                  class="btn btn-success modal-action-btn"
                  :disabled="salvando"
                  @click="abrirFormCriarReceitaAbatimento"
                >
                  Criar receita de abatimento
                </button>
              </div>
            </div>

            <div
              v-if="isPagamentoConsolidadoBanco && tratamentoDiferencaComposta === 'ABATIMENTO'"
              class="info-box conciliacao-composta-box mt-3"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>Receitas disponíveis para abatimento</strong>
                  <div class="text-muted">
                    Selecione uma receita ainda não conciliada para abater o pagamento consolidado.
                  </div>
                </div>

                <span class="status-badge is-blue">
                  {{ candidatosCompostaReceitas.length }} receita(s)
                </span>
              </div>

              <div v-if="erroComposta" class="alert alert-danger py-2 mb-3">
                {{ erroComposta }}
              </div>

              <div v-if="carregandoComposta" class="text-muted py-2">
                Carregando receitas de abatimento...
              </div>

              <template v-else>
                <div class="table-scroll composta-table-scroll">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover mb-0">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Data</th>
                          <th>Origem</th>
                          <th class="text-end">Valor</th>
                          <th>Forma</th>
                          <th>Conta</th>
                          <th>Autorização</th>
                          <th>Score</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-if="!candidatosCompostaReceitas.length">
                          <td colspan="8" class="text-center text-muted py-3">
                            Nenhuma receita disponível encontrada para abatimento.
                          </td>
                        </tr>

                        <tr
                          v-for="cand in candidatosCompostaReceitas"
                          :key="`abatimento-receita-${cand.origem_tabela}-${cand.origem_id}`"
                          :class="{ 'row-selected': isReceitaCompostaSelecionada(cand) }"
                        >
                          <td>
                            <input
                              type="checkbox"
                              :checked="isReceitaCompostaSelecionada(cand)"
                              @change="toggleReceitaComposta(cand)"
                            />
                          </td>

                          <td>{{ formatDate(cand.dt_caixa) }}</td>

                          <td>
                            <div class="candidate-title">
                              {{ cand.descricao || cand.origem_tabela }}
                            </div>
                            <small class="text-muted">
                              {{ cand.origem_tabela }} #{{ cand.origem_id }}
                            </small>
                          </td>

                          <td class="text-end">{{ formatCurrency(cand.valor) }}</td>
                          <td>{{ cand.forma_pagamento_nome || '—' }}</td>
                          <td>{{ cand.conta_financeira_nome || cand.conta_financeira_id || '—' }}</td>
                          <td>{{ cand.numero_autorizacao || '—' }}</td>
                          <td>{{ cand.score ?? '—' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="composta-resumo mt-3">
                  <div class="composta-resumo-card">
                    <span>Total despesas selecionadas</span>
                    <strong>{{ formatCurrency(totalDespesasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Total receitas abatendo</span>
                    <strong>{{ formatCurrency(totalReceitasComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Saldo líquido</span>
                    <strong>{{ formatCurrency(saldoLiquidoComposta) }}</strong>
                  </div>

                  <div class="composta-resumo-card">
                    <span>Valor banco</span>
                    <strong>{{ formatCurrency(valorItem) }}</strong>
                  </div>

                  <div
                    class="composta-resumo-card"
                    :class="podeRevisarConciliacaoComposta ? 'composta-resumo-card--ok' : 'composta-resumo-card--alert'"
                  >
                    <span>Diferença</span>
                    <strong>{{ formatCurrency(diferencaComposta) }}</strong>
                    <small>{{ mensagemDiferencaComposta }}</small>
                  </div>
                </div>
              </template>
            </div>            

            <div
              v-if="mostrarFormCriarReceitaAbatimento"
              class="info-box receita-abatimento-box mt-3"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <strong>Criar Receita Geral de abatimento</strong>
                  <div class="text-muted">
                    Esta receita será criada para abater a composição do pagamento consolidado.
                  </div>
                </div>

                <span class="status-badge is-green">
                  Abatimento
                </span>
              </div>

              <div class="row g-2">
                <div class="col-md-8">
                  <label class="form-label">Descrição da receita</label>
                  <input
                    v-model="novaReceitaAbatimento.descricao"
                    type="text"
                    class="form-control"
                    placeholder="Ex.: Abatimento salário Amanda"
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label">Subconta</label>
                  <select
                    v-model="novaReceitaAbatimento.subconta_id"
                    class="form-control"
                    :disabled="carregandoSubcontas"
                  >
                    <option value="">
                      {{ carregandoSubcontas ? 'Carregando...' : 'Selecione a subconta' }}
                    </option>

                    <option
                      v-for="subconta in subcontasReceita"
                      :key="subconta.id"
                      :value="subconta.id"
                    >
                      {{ subconta.nome }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Valor da diferença</label>
                  <input
                    :value="formatCurrency(valorReceitaAbatimentoNecessario)"
                    type="text"
                    class="form-control"
                    disabled
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label">Data</label>
                  <input
                    :value="formatDate(props.item?.dt_movimento)"
                    type="text"
                    class="form-control"
                    disabled
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label">Forma</label>
                  <input
                    value="Sugerida automaticamente pelo histórico bancário"
                    type="text"
                    class="form-control"
                    disabled
                  />
                </div>

                <div class="col-12">
                  <label class="form-label">Observação</label>
                  <textarea
                    v-model="novaReceitaAbatimento.observacao"
                    class="form-control"
                    rows="2"
                    placeholder="Observação opcional"
                  ></textarea>
                </div>
              </div>

              <div
                v-if="!mostrarConfirmacaoCriarReceitaAbatimento"
                class="d-flex justify-content-end mt-3 gap-2"
              >
                <button
                  type="button"
                  class="btn btn-outline-secondary modal-action-btn"
                  :disabled="salvando"
                  @click="cancelarFormCriarReceitaAbatimento"
                >
                  Cancelar criação
                </button>

                <button
                  type="button"
                  class="btn btn-success modal-action-btn"
                  :disabled="salvando || !podeConfirmarCriacaoReceitaAbatimento"
                  @click="abrirConfirmacaoCriarReceitaAbatimento"
                >
                  Revisar criação
                </button>
              </div>

              <div
                v-if="mostrarConfirmacaoCriarReceitaAbatimento"
                class="confirmar-criacao-receita-box mt-3"
              >
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong>Confirmar criação da receita de abatimento</strong>
                  <span class="status-badge is-green">Confirmação</span>
                </div>

                <div class="confirmacao-receita-grid">
                  <div>
                    <span class="confirmacao-label">Valor</span>
                    <strong>{{ formatCurrency(valorReceitaAbatimentoNecessario) }}</strong>
                  </div>

                  <div>
                    <span class="confirmacao-label">Data</span>
                    <strong>{{ formatDate(props.item?.dt_movimento) }}</strong>
                  </div>

                  <div>
                    <span class="confirmacao-label">Subconta</span>
                    <strong>{{ subcontaSelecionadaReceitaAbatimento?.nome || '—' }}</strong>
                  </div>

                  <div>
                    <span class="confirmacao-label">Banco</span>
                    <strong>{{ formatCurrency(valorItem) }}</strong>
                  </div>
                </div>

                <div class="confirmacao-descricao mt-2">
                  <span class="confirmacao-label">Descrição</span>
                  <strong>{{ novaReceitaAbatimento.descricao || '—' }}</strong>
                </div>

                <div
                  v-if="novaReceitaAbatimento.observacao"
                  class="confirmacao-descricao mt-2"
                >
                  <span class="confirmacao-label">Observação</span>
                  <span>{{ novaReceitaAbatimento.observacao }}</span>
                </div>

                <div class="text-muted mt-2">
                  Essa ação criará a Receita Geral e confirmará a conciliação composta.
                </div>

                <div class="d-flex justify-content-end mt-3 gap-2">
                  <button
                    type="button"
                    class="btn btn-outline-secondary modal-action-btn"
                    :disabled="salvando"
                    @click="cancelarConfirmacaoCriarReceitaAbatimento"
                  >
                    Voltar para edição
                  </button>

                  <button
                    type="button"
                    class="btn btn-success modal-action-btn"
                    :disabled="salvando || !podeConfirmarCriacaoReceitaAbatimento"
                    @click="confirmarCriarReceitaAbatimentoEConciliar"
                  >
                    {{ salvando ? 'Criando e conciliando...' : 'Confirmar criação e conciliar' }}
                  </button>
                </div>
              </div>
            </div>            

            <div class="d-flex justify-content-end mt-3 gap-2">
              <button
                type="button"
                class="btn btn-primary modal-action-btn"
                :disabled="!podeConfirmarComposicaoOuAjuste"
                @click="abrirRevisaoConciliacaoComposta"
              >
                Revisar conciliação composta
              </button>
            </div>
          </div>          

          <div class="form-group mb-3">
            <label>Observação:</label>
            <textarea
              v-model="observacao"
              class="form-control"
              rows="3"
              :disabled="isVisualizacao"
              placeholder="Informe uma observação para a conciliação, se necessário."
            ></textarea>
          </div>
        </template>

        <template
          v-if="
            etapa === 'revisao' &&
            !mostrarFormCriarReceita &&
            !mostrarFormCriarDespesa &&
            !mostrarConfirmacaoAjustePix
          "
        >
          <div class="review-panel">
            <div class="review-title">
              <i class="bi bi-check2-circle"></i>
              Revisar conciliação
            </div>

            <div
              v-if="revisaoTipo === 'composta'"
              class="alert alert-info py-2 mb-3"
            >
              Esta conciliação será registrada como composição manual de receitas e despesas.
            </div>            

            <div class="review-grid mb-3">
              <div class="review-box">
                <div class="review-box__label">{{ origemTipoLabel }}</div>
                <div><strong>ID:</strong> {{ item?.id || '—' }}</div>
                <div><strong>Valor:</strong> {{ formatCurrency(valorItem) }}</div>

                <div v-if="origemTipo === 'OFX'">
                  <strong>Data:</strong> {{ formatDate(item?.dt_movimento) }}
                </div>

                <div v-if="origemTipo === 'OFX'">
                  <strong>Memo:</strong> {{ item?.memo || '—' }}
                </div>

                <div v-if="origemTipo === 'OPERADORA'">
                  <strong>Autorização:</strong> {{ item?.autorizacao || '—' }}
                </div>

                <div v-if="origemTipo === 'OPERADORA'">
                  <strong>Vencimento:</strong> {{ formatDate(item?.data_vencimento || item?.data_venda) }}
                </div>
              </div>

              <div class="review-box">
                <div class="review-box__label">Resumo</div>

                <template v-if="revisaoTipo === 'composta'">
                  <div><strong>Valor banco:</strong> {{ formatCurrency(valorItem) }}</div>
                  <div><strong>Total receitas:</strong> {{ formatCurrency(totalReceitasComposta) }}</div>
                  <div><strong>Total despesas:</strong> {{ formatCurrency(totalDespesasComposta) }}</div>
                  <div><strong>Saldo líquido:</strong> {{ formatCurrency(saldoLiquidoComposta) }}</div>
                  <div>
                    <strong>Diferença:</strong>
                    <span :class="diferencaAbsComposta <= 0.01 ? 'diff-ok' : 'diff-alert'">
                      {{ formatCurrency(diferencaComposta) }}
                    </span>
                  </div>
                  <div><strong>Tipo:</strong> Conciliação composta</div>
                </template>

                <template v-else>
                  <div><strong>Valor do item:</strong> {{ formatCurrency(valorItem) }}</div>
                  <div><strong>Soma selecionada:</strong> {{ formatCurrency(somaSelecionada) }}</div>
                  <div>
                    <strong>Diferença:</strong>
                    <span :class="differenceClass">
                      {{ formatCurrency(diferenca) }}
                    </span>
                  </div>
                  <div><strong>Tipo:</strong> {{ revisaoTipoLabel }}</div>
                </template>
              </div>
            </div>

            <div class="review-box mb-3">
              <div class="review-box__label">Lançamentos selecionados</div>

              <template v-if="revisaoTipo === 'composta'">
                <div
                  v-for="cand in despesasSelecionadasComposta"
                  :key="`rev-despesa-${cand.origem_tabela}-${cand.origem_id}`"
                  class="selected-item"
                >
                  <div>
                    <strong>{{ cand.descricao || cand.origem_tabela }}</strong>

                    <small class="text-muted d-block">
                      Despesa · {{ formatDate(cand.dt_caixa) }} · {{ cand.forma_pagamento_nome || 'Forma não informada' }}
                    </small>

                    <small class="text-muted d-block">
                      Papel: {{ isOfxDebito ? 'Compõe o pagamento' : 'Abate o recebimento' }}
                    </small>

                  </div>

                  <div class="selected-item__value text-end">
                    <div>
                      <small class="text-muted d-block">Valor original</small>
                      <span>{{ formatCurrency(getValorOriginalComposta(cand)) }}</span>
                    </div>

                    <div
                      v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO'"
                      class="mt-1"
                    >
                      <small class="text-muted d-block">Valor líquido</small>
                      <strong>{{ formatCurrency(getValorLiquidoPagamentoComposta(cand)) }}</strong>
                    </div>

                    <div
                      v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO' && getDescontoPagamentoComposta(cand) > 0"
                      class="mt-1"
                    >
                      <small class="text-muted d-block">Desconto</small>
                      <span class="diff-alert">{{ formatCurrency(getDescontoPagamentoComposta(cand)) }}</span>
                    </div>

                    <div
                      v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO' && getJurosPagamentoComposta(cand) > 0"
                      class="mt-1"
                    >
                      <small class="text-muted d-block">Juros</small>
                      <span>{{ formatCurrency(getJurosPagamentoComposta(cand)) }}</span>
                    </div>

                    <div
                      v-if="tratamentoDiferencaComposta === 'AJUSTAR_PAGAMENTO' && getMultaPagamentoComposta(cand) > 0"
                      class="mt-1"
                    >
                      <small class="text-muted d-block">Multa</small>
                      <span>{{ formatCurrency(getMultaPagamentoComposta(cand)) }}</span>
                    </div>
                  </div>

                </div>

              </template>

              <template v-else>
                <div
                  v-for="cand in selecionados"
                  :key="`${cand.origem_tabela}-${cand.origem_id}`"
                  class="selected-item"
                >
                  <div>
                    <strong>{{ cand.descricao || cand.origem_tabela }}</strong>

                    <small class="text-muted d-block">
                      {{ formatDate(getDataConsideradaConciliacao(cand)) }} · {{ cand.forma_pagamento_nome || 'Forma não informada' }}
                    </small>

                    <small
                      v-if="isChequeDevolvido(cand)"
                      class="text-danger d-block"
                    >
                      Este vínculo será registrado como cheque devolvido.
                    </small>

                    <small
                      v-if="isChequeReapresentado(cand)"
                      class="text-warning d-block"
                    >
                      Este vínculo será registrado como cheque reapresentado.
                    </small>                    


                    <small v-if="chequeFisicoPossuiMaisDeUmLancamento(cand)" class="text-primary d-block">
                      Cheque físico {{ cand.cheque_numero || cand.cheque_numero_normalizado || '—' }} compartilhado por {{ candidatosDoMesmoChequeFisico(cand).length }} lançamentos.
                    </small>

                    <small v-if="cand.cheque_evento_posterior" class="text-muted d-block">
                      Evidência posterior: {{ formatDate(cand.cheque_evento_posterior.dt_movimento) }} ·
                      {{ formatCurrency(cand.cheque_evento_posterior.valor_abs || cand.cheque_evento_posterior.valor) }} ·
                      {{ cand.cheque_evento_posterior.memo || 'Movimento bancário de cheque' }}
                    </small>

                    <small
                      v-if="isPixPessoaIdentificada(cand)"
                      class="text-primary d-block"
                    >
                      PIX identificado para {{ cand.pix_pessoa_nome || 'pessoa relacionada' }}.
                    </small>

                    <small
                      v-if="isPixAjusteNecessario(cand)"
                      class="text-warning d-block"
                    >
                      Este lançamento possui divergências e precisará ser ajustado antes da conciliação.
                    </small>

                    <div
                      v-if="temDivergencias(cand)"
                      class="pix-divergences mt-1"
                    >
                      <span
                        v-for="div in listarDivergencias(cand)"
                        :key="div"
                        class="divergence-badge"
                      >
                        {{ div }}
                      </span>
                    </div>

                    <small
                      v-if="cand.cheque_numero_alerta"
                      class="text-warning d-block"
                    >
                      {{ cand.cheque_numero_alerta }}
                      <span v-if="cand.cheque_numero_banco">
                        OFX: {{ cand.cheque_numero_banco }}
                      </span>
                    </small>

                    <small
                      v-if="isConsolidadoParcial(cand)"
                      class="text-warning d-block"
                    >
                      Este item utilizará apenas parte do lançamento do sistema.
                    </small>

                    <small
                      v-if="isConsolidadoParcial(cand)"
                      class="text-muted d-block"
                    >
                      Valor original do lançamento: {{ formatCurrency(cand.valor) }}
                    </small>

                    <small
                      v-if="isConsolidadoParcial(cand)"
                      class="text-muted d-block"
                    >
                      Saldo disponível antes: {{ formatCurrency(cand.saldo_disponivel) }}
                    </small>

                    <small
                      v-if="isConsolidadoParcial(cand)"
                      class="text-muted d-block"
                    >
                      Saldo após a conciliação:
                      {{ formatCurrency(Math.max(Number(cand.saldo_disponivel || 0) - Number(valorItem || 0), 0)) }}
                    </small>
                  </div>

                  <div class="selected-item__value">
                    {{ formatCurrency(getValorConsideradoConciliacao(cand)) }}
                  </div>
                </div>
              </template>
            </div>

            <div v-if="observacao" class="review-box mb-3">
              <div class="review-box__label">Observação</div>
              <div class="white-space-pre-line">{{ observacao }}</div>
            </div>

            <div
              v-if="temSelecionadoComAjuste"
              class="alert alert-warning py-2 mb-3"
            >
              Este candidato foi encontrado pelo identificador do PIX, mas possui divergências de valor, data ou forma de pagamento.
              A conciliação direta ainda não será permitida nesta etapa. Na próxima etapa, criaremos a ação “Ajustar e conciliar”.
            </div>

            <div v-if="!podeConfirmar && revisaoTipo === 'normal'" class="alert alert-danger py-2 mb-3">
              A diferença está fora da tolerância permitida. Volte para a seleção e ajuste os lançamentos escolhidos.
            </div>

            <div v-if="!podeConfirmarConsolidado && revisaoTipo === 'consolidado'" class="alert alert-danger py-2 mb-3">
              O saldo disponível do lançamento consolidado é insuficiente para este item.
            </div>

            <div
              v-if="!podeConfirmarComposicaoOuAjuste && revisaoTipo === 'composta'"
              class="alert alert-danger py-2 mb-3"
            >
              A composição não fecha com o valor do banco. Volte para a seleção e ajuste os lançamentos escolhidos.
            </div>
          </div>
        </template>
      </div>

      <div class="modal-footer">
        <button
          v-if="etapa === 'revisao' && !isVisualizacao"
          class="btn btn-outline-secondary me-2 modal-action-btn"
          @click="voltarParaSelecao"
          :disabled="salvando"
        >
          Voltar para seleção
        </button>

        <button
          class="btn btn-secondary me-2 modal-action-btn"
          @click="$emit('close')"
          :disabled="salvando"
        >
          {{ isVisualizacao ? 'Fechar' : 'Cancelar' }}
        </button>

        <template v-if="!isVisualizacao && etapa === 'selecao'">
          <!-- Fluxo: Criar Receita e Conciliar -->
          <template v-if="podeCriarReceitaConciliar">
            <button
              v-if="!mostrarFormCriarReceita"
              class="btn btn-success me-2 modal-action-btn"
              @click="abrirFormCriarReceita"
              :disabled="salvando"
            >
              Criar receita
            </button>

            <button
              v-else-if="mostrarFormCriarReceita && !mostrarConfirmacaoCriarReceita"
              class="btn btn-success me-2 modal-action-btn"
              @click="abrirConfirmacaoCriarReceita"
              :disabled="salvando || !podeConfirmarCriacaoReceita"
            >
              Revisar criação
            </button>

            <button
              v-else-if="mostrarFormCriarReceita && mostrarConfirmacaoCriarReceita"
              class="btn btn-success me-2 modal-action-btn"
              @click="confirmarCriarReceitaEConciliar"
              :disabled="salvando || !podeConfirmarCriacaoReceita"
            >
              {{ salvando ? 'Criando e conciliando...' : 'Confirmar criação e conciliar' }}
            </button>

            <button
              v-if="mostrarFormCriarReceita && !mostrarConfirmacaoCriarReceita"
              class="btn btn-outline-secondary me-2 modal-action-btn"
              @click="cancelarFormCriarReceita"
              :disabled="salvando"
            >
              Cancelar criação
            </button>

            <button
              v-if="mostrarFormCriarReceita && mostrarConfirmacaoCriarReceita"
              class="btn btn-outline-secondary me-2 modal-action-btn"
              @click="cancelarConfirmacaoCriarReceita"
              :disabled="salvando"
            >
              Voltar para edição
            </button>
          </template>

          <!-- Fluxo: Criar Despesa e Conciliar -->
          <template v-else-if="podeCriarDespesaConciliar">
            <button
              v-if="!mostrarFormCriarDespesa"
              class="btn btn-warning me-2 modal-action-btn"
              @click="abrirFormCriarDespesa"
              :disabled="salvando"
            >
              Criar despesa
            </button>

            <button
              v-else-if="mostrarFormCriarDespesa && !mostrarConfirmacaoCriarDespesa"
              class="btn btn-warning me-2 modal-action-btn"
              @click="abrirConfirmacaoCriarDespesa"
              :disabled="salvando || !podeConfirmarCriacaoDespesa"
            >
              Revisar criação
            </button>

            <button
              v-else-if="mostrarFormCriarDespesa && mostrarConfirmacaoCriarDespesa"
              class="btn btn-warning me-2 modal-action-btn"
              @click="confirmarCriarDespesaEConciliar"
              :disabled="salvando || !podeConfirmarCriacaoDespesa"
            >
              {{ salvando ? 'Criando e conciliando...' : 'Confirmar criação e conciliar' }}
            </button>

            <button
              v-if="mostrarFormCriarDespesa && !mostrarConfirmacaoCriarDespesa"
              class="btn btn-outline-secondary me-2 modal-action-btn"
              @click="cancelarFormCriarDespesa"
              :disabled="salvando"
            >
              Cancelar criação
            </button>

            <button
              v-if="mostrarFormCriarDespesa && mostrarConfirmacaoCriarDespesa"
              class="btn btn-outline-secondary me-2 modal-action-btn"
              @click="cancelarConfirmacaoCriarDespesa"
              :disabled="salvando"
            >
              Voltar para edição
            </button>
          </template>

          <!-- Fluxo normal: Conciliar candidatos existentes / Ajustar PIX / Consolidado -->
          <template v-else>
            <button
              v-if="candidatoComAjusteSelecionado && !mostrarConfirmacaoAjustePix"
              class="btn btn-warning me-2 modal-action-btn"
              @click="abrirConfirmacaoAjustePix"
              :disabled="salvando || !podeAjustarConciliar"
            >
              Ajustar e conciliar
            </button>

            <button
              v-if="candidatoComAjusteSelecionado && mostrarConfirmacaoAjustePix"
              class="btn btn-warning me-2 modal-action-btn"
              @click="confirmarComAjuste"
              :disabled="salvando || !podeAjustarConciliar"
            >
              {{ salvando ? 'Ajustando e conciliando...' : 'Confirmar ajuste e conciliar' }}
            </button>

            <button
              v-if="candidatoComAjusteSelecionado && mostrarConfirmacaoAjustePix"
              class="btn btn-outline-secondary me-2 modal-action-btn"
              @click="cancelarConfirmacaoAjustePix"
              :disabled="salvando"
            >
              Voltar para seleção
            </button>

            <button
              v-if="!candidatoComAjusteSelecionado && !candidatoConsolidadoSelecionado"
              class="btn btn-primary me-2 modal-action-btn"
              @click="abrirRevisao('normal')"
              :disabled="salvando || !selecionados.length || !podeConfirmar"
            >
              Revisar conciliação
            </button>

            <button
              v-if="!candidatoComAjusteSelecionado && candidatoConsolidadoSelecionado"
              class="btn btn-warning modal-action-btn"
              @click="abrirRevisao('consolidado')"
              :disabled="salvando || !podeConfirmarConsolidado"
            >
              Revisar vínculo parcial
            </button>
          </template>
        </template>

        <template v-if="!isVisualizacao && etapa === 'revisao'">
          <button
            v-if="revisaoTipo === 'normal'"
            class="btn btn-primary modal-action-btn"
            @click="confirmar"
            :disabled="salvando || !selecionados.length || !podeConfirmar"
          >
            {{ salvando ? 'Salvando e atualizando...' : 'Confirmar conciliação' }}
          </button>

          <button
            v-if="revisaoTipo === 'consolidado'"
            class="btn btn-warning modal-action-btn"
            @click="confirmarConsolidado"
            :disabled="salvando || !podeConfirmarConsolidado"
          >
            {{ salvando ? 'Salvando e atualizando...' : 'Confirmar vínculo consolidado' }}
          </button>

          <button
            v-if="revisaoTipo === 'composta'"
            class="btn btn-primary modal-action-btn"
            @click="confirmarComposta"
            :disabled="salvando || !podeConfirmarComposicaoOuAjuste"
          >
            {{ salvando ? 'Salvando e atualizando...' : 'Confirmar conciliação composta' }}
          </button>
        </template>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import axios from '@/services/axios'
import {
  listarCandidatos,
  listarCandidatosConciliacaoComposta,
  confirmarConciliacaoComposta,
  criarReceitaAbatimentoEConfirmarComposta,
  ajustarPagamentosEConfirmarComposta,
  conciliarManual,
  conciliarConsolidado,
  conciliarComAjuste,
  criarReceitaEConciliar,
  criarDespesaEConciliar
} from '@/services/conciliacaoBancaria.api'

const props = defineProps({
  origemTipo: { type: String, required: true },
  item: { type: Object, required: true },
  dataInicio: { type: String, default: '' },
  dataFim: { type: String, default: '' },
  modo: { type: String, default: 'edicao' },
  vinculados: { type: Array, default: () => [] },
  taxaOperadora: { type: Object, default: null }
})

const emit = defineEmits(['close', 'salvo'])

const loading = ref(false)
const salvando = ref(false)
const erro = ref('')
const candidatos = ref([])
const selecionados = ref([])
const observacao = ref('')
const aviso = ref('')

const carregandoComposta = ref(false)
const mostrarConciliacaoComposta = ref(false)
const candidatosCompostaReceitas = ref([])
const candidatosCompostaDespesas = ref([])
const receitasSelecionadasComposta = ref([])
const despesasSelecionadasComposta = ref([])
const erroComposta = ref('')
const tratamentoDiferencaComposta = ref('')
const ajustesPagamentosComposta = ref({})

const mostrarFormCriarReceita = ref(false)
const subcontasReceita = ref([])
const carregandoSubcontas = ref(false)

const mostrarConfirmacaoCriarReceita = ref(false)
const mostrarConfirmacaoAjustePix = ref(false)

const novaReceita = ref({
  descricao: '',
  subconta_id: '',
  observacao: ''
})

const mostrarFormCriarReceitaAbatimento = ref(false)
const mostrarConfirmacaoCriarReceitaAbatimento = ref(false)

const novaReceitaAbatimento = ref({
  descricao: '',
  subconta_id: '',
  observacao: ''
})

const mostrarFormCriarDespesa = ref(false)
const subcontasDespesa = ref([])
const formasPagamentoDespesa = ref([])
const carregandoDespesaListas = ref(false)

const mostrarConfirmacaoCriarDespesa = ref(false)

const novaDespesa = ref({
  descricao: '',
  subconta_id: '',
  forma_pagamento_id: '',
  observacao: ''
})

const etapa = ref('selecao')
const revisaoTipo = ref(null)

const TOLERANCIA_CONCILIACAO_OPERADORA = 0.10

const isVisualizacao = computed(() => props.modo === 'visualizacao')

const tituloModal = computed(() =>
  isVisualizacao.value ? 'Detalhar conciliação' : 'Conciliação manual'
)

const origemTipoLabel = computed(() => {
  const origem = String(props.origemTipo || '').toUpperCase()

  if (origem === 'OFX') return 'Banco'
  if (origem === 'OPERADORA') return 'Operadora'

  return origem || 'Origem'
})

const valorItem = computed(() => {
  const valor = Number(
    props.item?.valor ??
    props.item?.valor_parcela ??
    props.item?.valor_bruto ??
    props.item?.valor_liquido ??
    0
  )

  return Math.abs(valor)
})

const somaSelecionada = computed(() =>
  selecionados.value.reduce((acc, item) => {
    return acc + Math.abs(Number(getValorConsideradoConciliacao(item) || 0))
  }, 0)
)

const temAjustePagamentoComposta = computed(() =>
  tratamentoDiferencaComposta.value === 'AJUSTAR_PAGAMENTO' &&
  despesasSelecionadasComposta.value.length > 0
)

const valorSistemaResumo = computed(() => {
  if (temConciliacaoCompostaDetalhe.value) {
    return saldoLiquidoConciliacaoCompostaDetalhe.value
  }

  if (revisaoTipo.value === 'composta' || temAjustePagamentoComposta.value) {
    return saldoLiquidoComposta.value
  }

  return somaSelecionada.value
})

const diferencaResumo = computed(() => {
  if (temConciliacaoCompostaDetalhe.value) {
    return diferencaConciliacaoCompostaDetalhe.value
  }

  if (revisaoTipo.value === 'composta' || temAjustePagamentoComposta.value) {
    return diferencaComposta.value
  }

  return diferenca.value
})

const diferencaAbsResumo = computed(() =>
  Math.abs(Number(diferencaResumo.value || 0))
)

const memoItemBanco = computed(() =>
  String(props.item?.memo || props.item?.historico || props.item?.descricao || '').trim()
)

const diferenca = computed(() =>
  Number((valorItem.value - somaSelecionada.value).toFixed(2))
)

const diferencaAbs = computed(() =>
  Math.abs(Number(diferenca.value || 0))
)

const podeConfirmar = computed(() => {
  if (String(props.origemTipo || '').toUpperCase() === 'OPERADORA') {
    return diferencaAbs.value <= TOLERANCIA_CONCILIACAO_OPERADORA
  }

  return diferencaAbs.value <= 0.01
})

const differenceClass = computed(() => {
  if (temConciliacaoCompostaDetalhe.value) {
    return diferencaAbsResumo.value <= 0.01 ? 'diff-ok' : 'diff-alert'
  }

  if (String(props.origemTipo || '').toUpperCase() === 'OPERADORA') {
    if (diferencaAbs.value <= 0.01) return 'diff-ok'
    if (diferencaAbs.value <= TOLERANCIA_CONCILIACAO_OPERADORA) return 'diff-tolerated'
    return 'diff-alert'
  }

  if (diferencaAbs.value <= 0.01) return 'diff-ok'
  return 'diff-alert'
})

const differenceCardClass = computed(() => {
  if (differenceClass.value === 'diff-ok') return 'summary-card--ok'
  if (differenceClass.value === 'diff-tolerated') return 'summary-card--tolerated'
  return 'summary-card--alert'
})

const diferencaMensagem = computed(() => {
  if (!selecionados.value.length && !isVisualizacao.value) {
    return 'Nenhum lançamento selecionado.'
  }

  if (diferencaAbs.value <= 0.01) {
    return 'Valores conferem.'
  }

  if (
    String(props.origemTipo || '').toUpperCase() === 'OPERADORA' &&
    diferencaAbs.value <= TOLERANCIA_CONCILIACAO_OPERADORA
  ) {
    return 'Dentro da tolerância de arredondamento.'
  }

  if (diferenca.value > 0) {
    return `Ainda falta selecionar ${formatCurrency(diferencaAbs.value)}.`
  }

  return `Selecionado acima do valor em ${formatCurrency(diferencaAbs.value)}.`
})

const diferencaMensagemResumo = computed(() => {
  if (temConciliacaoCompostaDetalhe.value) {
    if (diferencaAbsResumo.value <= 0.01) {
      return 'Composição fechada.'
    }

    if (diferencaResumo.value > 0) {
      return `Ainda falta ${formatCurrency(diferencaAbsResumo.value)}.`
    }

    return `Composição acima do valor em ${formatCurrency(diferencaAbsResumo.value)}.`
  }

  return diferencaMensagem.value
})

const avisoTolerancia = computed(() => {
  return (
    String(props.origemTipo || '').toUpperCase() === 'OPERADORA' &&
    diferencaAbs.value > 0.01 &&
    diferencaAbs.value <= TOLERANCIA_CONCILIACAO_OPERADORA
  )
})

const candidatoConsolidadoSelecionado = computed(() => {
  if (selecionados.value.length !== 1) return null

  const cand = selecionados.value[0]

  return isConsolidadoParcial(cand) ? cand : null
})

const podeConfirmarConsolidado = computed(() => {
  const cand = candidatoConsolidadoSelecionado.value
  if (!cand) return false

  const saldoDisponivel = Math.abs(Number(cand?.saldo_disponivel ?? 0))
  const valorNecessario = Math.abs(Number(valorItem.value || 0))

  return saldoDisponivel + 0.01 >= valorNecessario
})

const revisaoTipoLabel = computed(() => {
  if (revisaoTipo.value === 'consolidado') {
    return 'Consolidado parcial'
  }

  if (
    (selecionados.value || []).some(
      isOperadoraAutorizacaoAgrupada
    )
  ) {
    return 'Autorização agrupada'
  }

  return 'Normal'
})

const exibirBlocoTaxaOperadora = computed(() =>
  isVisualizacao.value &&
  String(props.origemTipo || '').toUpperCase() === 'OPERADORA'
)

const taxaOperadoraStatusLabel = computed(() => {
  const status = String(props.taxaOperadora?.status || '').toUpperCase()
  if (!status) return 'Não gerada'
  if (status === 'ATIVO') return 'Gerada'
  if (status === 'DESFEITO') return 'Desfeita'
  return status
})

const vinculadosChequeDevolvido = computed(() =>
  (candidatos.value || []).filter((item) => isChequeDevolvido(item))
)

const temChequeDevolvido = computed(() =>
  vinculadosChequeDevolvido.value.length > 0
)

const vinculadosChequeReapresentado = computed(() =>
  (candidatos.value || []).filter((item) => isChequeReapresentado(item))
)

const temChequeReapresentado = computed(() =>
  vinculadosChequeReapresentado.value.length > 0
)

const vinculadosDepositoChequeAgrupado = computed(() =>
  (candidatos.value || []).filter((item) =>
    String(item?.tipo_vinculo || item?.tipo_vinculo_sugerido || '').toUpperCase() === 'CHEQUE_DEPOSITO_AGRUPADO'
  )
)

const temDepositoChequeAgrupado = computed(() =>
  vinculadosDepositoChequeAgrupado.value.length > 0
)

const temMultiplasCombinacoesCheque = computed(() =>
  (candidatos.value || []).some((cand) =>
    cand?.deposito_cheque_auto_selecionar === false ||
    String(cand?.tipo_candidato || '').toUpperCase() ===
      'DEPOSITO_CHEQUE_MULTIPLAS_COMBINACOES'
  )
)

const quantidadeCombinacoesCheque = computed(() => {
  const candidato = (candidatos.value || []).find(
    (cand) => Number(cand?.deposito_cheque_quantidade_combinacoes || 0) > 0
  )
  return Number(candidato?.deposito_cheque_quantidade_combinacoes || 0)
})

const composicaoChequeConfiavel = computed(() =>
  (candidatos.value || []).some((cand) =>
    cand?.deposito_cheque_combinacao_confiavel === true ||
    cand?.deposito_cheque_auto_selecionar === true
  )
)

const totalDepositoChequeAgrupado = computed(() =>
  vinculadosDepositoChequeAgrupado.value.reduce((acc, item) => {
    return acc + Math.abs(Number(item.valor_utilizado || item.valor || 0))
  }, 0)
)

const diferencaDepositoChequeAgrupado = computed(() =>
  Number((valorItem.value - totalDepositoChequeAgrupado.value).toFixed(2))
)

const quantidadeChequesFisicosDeposito = computed(() => {
  const chaves = new Set()
  for (const item of vinculadosDepositoChequeAgrupado.value) {
    const chaveFisica = chaveChequeFisico(item)
    chaves.add(chaveFisica || chave(item))
  }
  return chaves.size
})

const vinculadosComAjustePix = computed(() =>
  (candidatos.value || []).filter((item) => Boolean(item?.ajuste_pix_realizado))
)

const temAjustePix = computed(() =>
  vinculadosComAjustePix.value.length > 0
)

const vinculadosComReceitaCriada = computed(() =>
  (candidatos.value || []).filter((item) => Boolean(item?.receita_criada_conciliacao))
)

const temReceitaCriadaConciliacao = computed(() =>
  vinculadosComReceitaCriada.value.length > 0
)

const vinculadosComReceitaAbatimentoCriada = computed(() =>
  (candidatos.value || []).filter((item) => Boolean(item?.receita_abatimento_criada_conciliacao))
)

const vinculadosComAjustePagamento = computed(() =>
  (candidatos.value || []).filter((item) => {
    if (!item?.ajuste_pagamento_conciliacao) return false

    const ajuste = item.ajuste_pagamento_payload || {}

    const juros = Number(ajuste.juros || 0)
    const multa = Number(ajuste.multa || 0)
    const desconto = Number(ajuste.desconto || 0)

    return juros > 0 || multa > 0 || desconto > 0
  })
)

const temAjustePagamentoDetalhe = computed(() =>
  vinculadosComAjustePagamento.value.length > 0
)

const temReceitaAbatimentoCriada = computed(() =>
  vinculadosComReceitaAbatimentoCriada.value.length > 0
)

const vinculadosComDespesaCriada = computed(() =>
  (candidatos.value || []).filter((item) => Boolean(item?.despesa_criada_conciliacao))
)

const temDespesaCriadaConciliacao = computed(() =>
  vinculadosComDespesaCriada.value.length > 0
)

const TIPOS_CONCILIACAO_COMPOSTA = [
  'RECEITA_COMPOE_CONCILIACAO',
  'DESPESA_COMPOE_CONCILIACAO',
  'RECEITA_ABATE_CONCILIACAO',
  'DESPESA_ABATE_CONCILIACAO'
]

const vinculadosConciliacaoComposta = computed(() =>
  (candidatos.value || []).filter((item) =>
    TIPOS_CONCILIACAO_COMPOSTA.includes(
      String(item?.tipo_vinculo || '').toUpperCase()
    )
  )
)

const temConciliacaoCompostaDetalhe = computed(() =>
  isVisualizacao.value &&
  vinculadosConciliacaoComposta.value.length > 0
)

const vinculadosConsolidadoParcial = computed(() =>
  (candidatos.value || []).filter((item) =>
    isConsolidadoParcial(item)
  )
)

const temConsolidadoParcialDetalhe = computed(() =>
  isVisualizacao.value &&
  vinculadosConsolidadoParcial.value.length > 0
)

const receitasCompoemConciliacaoComposta = computed(() =>
  vinculadosConciliacaoComposta.value.filter((item) =>
    String(item?.tipo_vinculo || '').toUpperCase() === 'RECEITA_COMPOE_CONCILIACAO'
  )
)

const despesasCompoemConciliacaoComposta = computed(() =>
  vinculadosConciliacaoComposta.value.filter((item) =>
    String(item?.tipo_vinculo || '').toUpperCase() === 'DESPESA_COMPOE_CONCILIACAO'
  )
)

const receitasAbatemConciliacaoComposta = computed(() =>
  vinculadosConciliacaoComposta.value.filter((item) =>
    String(item?.tipo_vinculo || '').toUpperCase() === 'RECEITA_ABATE_CONCILIACAO'
  )
)

const despesasAbatemConciliacaoComposta = computed(() =>
  vinculadosConciliacaoComposta.value.filter((item) =>
    String(item?.tipo_vinculo || '').toUpperCase() === 'DESPESA_ABATE_CONCILIACAO'
  )
)

const totalReceitasCompoemDetalhe = computed(() =>
  receitasCompoemConciliacaoComposta.value.reduce((acc, item) => {
    return acc + Math.abs(Number(item.valor_utilizado || item.valor || 0))
  }, 0)
)

const totalDespesasCompoemDetalhe = computed(() =>
  despesasCompoemConciliacaoComposta.value.reduce((acc, item) => {
    return acc + Math.abs(Number(item.valor_utilizado || item.valor || 0))
  }, 0)
)

const totalReceitasAbatemDetalhe = computed(() =>
  receitasAbatemConciliacaoComposta.value.reduce((acc, item) => {
    return acc + Math.abs(Number(item.valor_utilizado || item.valor || 0))
  }, 0)
)

const totalDespesasAbatemDetalhe = computed(() =>
  despesasAbatemConciliacaoComposta.value.reduce((acc, item) => {
    return acc + Math.abs(Number(item.valor_utilizado || item.valor || 0))
  }, 0)
)

const saldoLiquidoConciliacaoCompostaDetalhe = computed(() => {
  if (Number(props.item?.valor || 0) < 0) {
    return Number((totalDespesasCompoemDetalhe.value - totalReceitasAbatemDetalhe.value).toFixed(2))
  }

  if (Number(props.item?.valor || 0) > 0) {
    return Number((totalReceitasCompoemDetalhe.value - totalDespesasAbatemDetalhe.value).toFixed(2))
  }

  return 0
})

const diferencaConciliacaoCompostaDetalhe = computed(() =>
  Number((valorItem.value - saldoLiquidoConciliacaoCompostaDetalhe.value).toFixed(2))
)

const temSelecionadoComAjuste = computed(() =>
  selecionados.value.some((item) => isPixAjusteNecessario(item))
)

const candidatoComAjusteSelecionado = computed(() => {
  if (selecionados.value.length !== 1) return null

  const cand = selecionados.value[0]

  if (!isPixAjusteNecessario(cand)) return null

  return cand
})

const podeAjustarConciliar = computed(() =>
  Boolean(candidatoComAjusteSelecionado.value) &&
  String(props.origemTipo || '').toUpperCase() === 'OFX'
)

const identificadorPixMemo = computed(() => {
  const memo = String(props.item?.memo || '').toUpperCase().trim()

  if (!memo.includes('PIX RECEBIDO')) return ''

  const numeros = memo.replace('PIX RECEBIDO', '').replace(/\D/g, '')

  if (numeros.length < 10 || numeros.length > 11) return ''

  return numeros
})

const isPixRecebidoItem = computed(() => {
  const memo = String(props.item?.memo || '').toUpperCase()
  return String(props.origemTipo || '').toUpperCase() === 'OFX' && memo.includes('PIX RECEBIDO')
})

const isOfxCredito = computed(() =>
  String(props.origemTipo || '').toUpperCase() === 'OFX' &&
  Number(props.item?.valor || 0) > 0
)

const isOfxDebito = computed(() =>
  String(props.origemTipo || '').toUpperCase() === 'OFX' &&
  Number(props.item?.valor || 0) < 0
)

const temCandidatoPixComPessoa = computed(() =>
  (candidatos.value || []).some((cand) => isPixPessoaIdentificada(cand))
)

const motivoPendenciaItem = computed(() =>
  String(props.item?.motivo_pendencia || '').trim()
)

const temPessoaIdentificadaNoMotivoPendencia = computed(() =>
  motivoPendenciaItem.value.toLowerCase().includes('pessoa identificada pelo pix')
)

const mostrarAvisoPixPessoaIdentificadaPendencia = computed(() =>
  !isVisualizacao.value &&
  isPixRecebidoItem.value &&
  Boolean(identificadorPixMemo.value) &&
  temPessoaIdentificadaNoMotivoPendencia.value &&
  !temCandidatoPixComPessoa.value
)

const tituloAvisoPixPessoaIdentificada = computed(() => {
  const texto = motivoPendenciaItem.value

  const match = texto.match(/Pessoa identificada pelo PIX:\s*([^.]+)\./i)

  if (match?.[1]) {
    return `Pessoa identificada pelo PIX: ${match[1].trim()}`
  }

  return 'Pessoa identificada pelo PIX'
})

const textoAvisoPixPessoaIdentificada = computed(() => {
  const texto = motivoPendenciaItem.value

  return texto
    .replace(/Pessoa identificada pelo PIX:\s*[^.]+\.\s*/i, '')
    .trim() || 'Existem lançamentos possíveis, mas é necessária revisão manual.'
})

const mostrarAvisoPixSemPessoa = computed(() =>
  !isVisualizacao.value &&
  isPixRecebidoItem.value &&
  Boolean(identificadorPixMemo.value) &&
  candidatos.value.length > 1 &&
  !temCandidatoPixComPessoa.value &&
  !temPessoaIdentificadaNoMotivoPendencia.value
)

const podeCriarReceitaConciliar = computed(() =>
  !isVisualizacao.value &&
  isOfxCredito.value &&
  !loading.value &&
  candidatos.value.length === 0 &&
  selecionados.value.length === 0
)

const podeCriarDespesaConciliar = computed(() =>
  !isVisualizacao.value &&
  isOfxDebito.value &&
  !loading.value &&
  candidatos.value.length === 0 &&
  selecionados.value.length === 0
)

const podeMostrarConciliacaoComposta = computed(() =>
  !isVisualizacao.value &&
  String(props.origemTipo || '').toUpperCase() === 'OFX' &&
  String(props.item?.status_conciliacao || '').toUpperCase() === 'PENDENTE' &&
  String(props.item?.tipo_pendencia || '').toUpperCase() === 'SEM_LANCAMENTO_SISTEMA' &&
  !props.item?.vinculo_id &&
  !props.item?.banco_operadora_vinculo_id
)

const isPagamentoConsolidadoBanco = computed(() =>
  !isVisualizacao.value &&
  String(props.origemTipo || '').toUpperCase() === 'OFX' &&
  String(props.item?.status_conciliacao || '').toUpperCase() === 'PENDENTE' &&
  String(props.item?.tipo_pendencia || '').toUpperCase() === 'PAGAMENTO_CONSOLIDADO' &&
  !props.item?.vinculo_id &&
  !props.item?.banco_operadora_vinculo_id
)


const totalCandidatosComposta = computed(() =>
  candidatosCompostaReceitas.value.length + candidatosCompostaDespesas.value.length
)

const totalReceitasComposta = computed(() =>
  receitasSelecionadasComposta.value.reduce((acc, item) => {
    return acc + getValorOriginalComposta(item)
  }, 0)
)

const totalDespesasComposta = computed(() =>
  despesasSelecionadasComposta.value.reduce((acc, item) => {
    if (tratamentoDiferencaComposta.value === 'AJUSTAR_PAGAMENTO') {
      return acc + getValorLiquidoPagamentoComposta(item)
    }

    return acc + getValorOriginalComposta(item)
  }, 0)
)

const saldoLiquidoComposta = computed(() => {
  if (isOfxDebito.value) {
    return Number((totalDespesasComposta.value - totalReceitasComposta.value).toFixed(2))
  }

  if (isOfxCredito.value) {
    return Number((totalReceitasComposta.value - totalDespesasComposta.value).toFixed(2))
  }

  return 0
})

const diferencaComposta = computed(() =>
  Number((valorItem.value - saldoLiquidoComposta.value).toFixed(2))
)

const diferencaAbsComposta = computed(() =>
  Math.abs(Number(diferencaComposta.value || 0))
)

const temSelecaoComposta = computed(() =>
  receitasSelecionadasComposta.value.length > 0 ||
  despesasSelecionadasComposta.value.length > 0
)

const podeRevisarConciliacaoComposta = computed(() =>
  temSelecaoComposta.value &&
  diferencaAbsComposta.value <= 0.01
)

const mensagemDiferencaComposta = computed(() => {
  if (!temSelecaoComposta.value) {
    return 'Nenhum lançamento selecionado.'
  }

  if (diferencaAbsComposta.value <= 0.01) {
    return 'Composição fechada.'
  }

  if (diferencaComposta.value > 0) {
    return `Ainda falta selecionar ${formatCurrency(diferencaAbsComposta.value)}.`
  }

  return `Selecionado acima do valor em ${formatCurrency(diferencaAbsComposta.value)}.`
})

const podeConfirmarComposicaoOuAjuste = computed(() =>
  podeRevisarConciliacaoComposta.value
)

const podeCriarReceitaAbatimento = computed(() =>
  isPagamentoConsolidadoBanco.value &&
  selecionados.value.length > 0 &&
  !podeConfirmarComposicaoOuAjuste.value
)

const mostrarTratamentoDiferencaComposta = computed(() =>
  temSelecaoComposta.value &&
  diferencaAbsComposta.value > 0.01
)

const textoTratamentoDiferencaComposta = computed(() => {
  if (!mostrarTratamentoDiferencaComposta.value) return ''

  if (isOfxDebito.value) {
    return 'Para débito bancário, despesas compõem o pagamento e receitas abatem o pagamento.'
  }

  if (isOfxCredito.value) {
    return 'Para crédito bancário, receitas compõem o recebimento e despesas abatem o recebimento.'
  }

  return 'A diferença deve ser tratada com correção do lançamento ou com lançamento financeiro de abatimento.'
})

const descricaoSugeridaDespesa = computed(() => {
  const memo = String(
    props.item?.memo ||
    props.item?.historico ||
    props.item?.descricao ||
    props.item?.classificacao ||
    ''
  ).trim()

  const data = formatDate(props.item?.dt_movimento)

  return `Despesa criada pela conciliação - ${memo || `OFX ${props.item?.id || ''}`} - ${data}`
})

const podeConfirmarCriacaoDespesa = computed(() =>
  Boolean(novaDespesa.value.descricao?.trim()) &&
  Boolean(novaDespesa.value.subconta_id) &&
  Boolean(novaDespesa.value.forma_pagamento_id)
)

const subcontaSelecionadaDespesa = computed(() =>
  subcontasDespesa.value.find(
    (item) => Number(item.id) === Number(novaDespesa.value.subconta_id)
  ) || null
)

const formaSelecionadaDespesa = computed(() =>
  formasPagamentoDespesa.value.find(
    (item) => Number(item.id) === Number(novaDespesa.value.forma_pagamento_id)
  ) || null
)

const descricaoSugeridaReceita = computed(() => {
  const memo = String(
    props.item?.memo ||
    props.item?.historico ||
    props.item?.descricao ||
    props.item?.classificacao ||
    ''
  ).trim()

  const data = formatDate(props.item?.dt_movimento)

  if (identificadorPixMemo.value) {
    return `Receita criada pela conciliação - PIX ${identificadorPixMemo.value} - ${data}`
  }

  return `Receita criada pela conciliação - ${memo || `OFX ${props.item?.id || ''}`}`
})

const podeConfirmarCriacaoReceita = computed(() =>
  Boolean(novaReceita.value.descricao?.trim()) &&
  Boolean(novaReceita.value.subconta_id)
)

const subcontaSelecionadaCriacao = computed(() =>
  subcontasReceita.value.find(
    (item) => Number(item.id) === Number(novaReceita.value.subconta_id)
  ) || null
)

const valorReceitaAbatimentoNecessario = computed(() =>
  Math.abs(Number(diferencaComposta.value || 0))
)

const descricaoSugeridaReceitaAbatimento = computed(() => {
  const memo = String(
    props.item?.memo ||
    props.item?.historico ||
    props.item?.descricao ||
    ''
  ).trim()

  const data = formatDate(props.item?.dt_movimento)

  return `Receita de abatimento - ${memo || `OFX ${props.item?.id || ''}`} - ${data}`
})

const podeConfirmarCriacaoReceitaAbatimento = computed(() =>
  Boolean(novaReceitaAbatimento.value.descricao?.trim()) &&
  Boolean(novaReceitaAbatimento.value.subconta_id) &&
  valorReceitaAbatimentoNecessario.value > 0.01
)

const subcontaSelecionadaReceitaAbatimento = computed(() =>
  subcontasReceita.value.find(
    (item) => Number(item.id) === Number(novaReceitaAbatimento.value.subconta_id)
  ) || null
)

const composicaoSugeridaMovimentacoes = computed(() => {
  const candidatos = props.item?.composicao_sugerida?.candidatos

  return Array.isArray(candidatos) ? candidatos : []
})

const temComposicaoSugeridaMovimentacoes = computed(() =>
  composicaoSugeridaMovimentacoes.value.length > 0
)


onMounted(() => {
  if (isVisualizacao.value) {
    candidatos.value = Array.isArray(props.vinculados) ? props.vinculados : []
    selecionados.value = Array.isArray(props.vinculados) ? [...props.vinculados] : []
    return
  }

  load()
})

async function load() {
  loading.value = true
  erro.value = ''

  try {
    const { data } = await listarCandidatos({
      origemTipo: props.origemTipo,
      origemItemId: props.item.id,
      dataInicio: props.dataInicio || undefined,
      dataFim: props.dataFim || undefined
    })

    candidatos.value = Array.isArray(data?.candidatos) ? data.candidatos : []
    aviso.value = data?.aviso || ''
    autoSelecionarLoteChequeAgrupado()
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao carregar candidatos.'
  } finally {
    loading.value = false
  }
}

async function carregarCandidatosConciliacaoComposta() {
  if (!podeMostrarConciliacaoComposta.value) return

  carregandoComposta.value = true
  erroComposta.value = ''
  mostrarConciliacaoComposta.value = true
  receitasSelecionadasComposta.value = []
  despesasSelecionadasComposta.value = []

  if (temComposicaoSugeridaMovimentacoes.value) {
    const sugeridos = composicaoSugeridaMovimentacoes.value
      .map(normalizarCandidatoComposicaoSugerida)

    const receitas = sugeridos.filter((item) => Number(item.valor || 0) > 0)
    const despesas = sugeridos.filter((item) => Number(item.valor || 0) < 0)

    candidatosCompostaReceitas.value = receitas
    candidatosCompostaDespesas.value = despesas

    if (isOfxCredito.value) {
      receitasSelecionadasComposta.value = [...receitas]
      despesasSelecionadasComposta.value = []
    } else if (isOfxDebito.value) {
      despesasSelecionadasComposta.value = [...despesas]
      receitasSelecionadasComposta.value = []
    }

    mostrarConciliacaoComposta.value = true
    carregandoComposta.value = false
    erroComposta.value = ''

    return
  }  
  
  try {
    const { data } = await listarCandidatosConciliacaoComposta({
      origemTipo: props.origemTipo,
      origemItemId: props.item.id,
      dataInicio: props.dataInicio || undefined,
      dataFim: props.dataFim || undefined
    })

    candidatosCompostaReceitas.value = Array.isArray(data?.receitas)
      ? data.receitas
      : []

    candidatosCompostaDespesas.value = Array.isArray(data?.despesas)
      ? data.despesas
      : []
  } catch (e) {
    erroComposta.value =
      e?.response?.data?.error ||
      'Erro ao carregar candidatos para conciliação composta.'

    candidatosCompostaReceitas.value = []
    candidatosCompostaDespesas.value = []
  } finally {
    carregandoComposta.value = false
  }
}

async function carregarSubcontasReceita() {
  carregandoSubcontas.value = true

  try {
    const { data } = await axios.get('/financeiro/subcontas', {
      params: {
        limit: 'all',
        sortBy: 'nome',
        order: 'ASC'
      }
    })

    const rows = Array.isArray(data?.data) ? data.data : []

    const somenteReceitas = rows.filter((item) => {
      const tipo = String(item?.tipo || '').toLowerCase()
      return tipo.includes('receita')
    })

    const collator = new Intl.Collator('pt-BR', {
      sensitivity: 'base',
      numeric: true
    })

    somenteReceitas.sort((a, b) =>
      collator.compare(a?.nome || '', b?.nome || '')
    )

    subcontasReceita.value = somenteReceitas
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao carregar subcontas de receita.'
    subcontasReceita.value = []
  } finally {
    carregandoSubcontas.value = false
  }
}

async function carregarListasDespesa() {
  carregandoDespesaListas.value = true

  try {
    const [subcontasRes, formasRes] = await Promise.all([
      axios.get('/financeiro/subcontas', {
        params: {
          tipo: 'Despesa',
          ativo: 'true',
          sortField: 'nome',
          sortOrder: 'asc',
          limit: 'all'
        }
      }),
      axios.get('/cadastros/formas-pagamento')
    ])

    const norm = (s) =>
      String(s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()

    subcontasDespesa.value = (subcontasRes.data?.data || [])
      .filter((sc) => norm(sc.nome) !== 'taxas da operadora')
      .sort((a, b) =>
        String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR', {
          sensitivity: 'base'
        })
      )

    const formas = (formasRes.data?.data ?? formasRes.data) || []

    formasPagamentoDespesa.value = formas
      .filter((forma) => String(forma?.nome || '').toLowerCase() !== 'brinde')
      .sort((a, b) =>
        String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR', {
          sensitivity: 'base'
        })
      )
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao carregar listas para criação da despesa.'
    subcontasDespesa.value = []
    formasPagamentoDespesa.value = []
  } finally {
    carregandoDespesaListas.value = false
  }
}

async function abrirFormCriarReceita() {
  erro.value = ''
  mostrarFormCriarReceita.value = true

  novaReceita.value = {
    descricao: descricaoSugeridaReceita.value,
    subconta_id: '',
    observacao: observacao.value || ''
  }

  if (!subcontasReceita.value.length) {
    await carregarSubcontasReceita()
  }
}

function cancelarFormCriarReceita() {
  mostrarFormCriarReceita.value = false
  mostrarConfirmacaoCriarReceita.value = false
}

async function abrirFormCriarDespesa() {
  erro.value = ''
  mostrarFormCriarDespesa.value = true

  novaDespesa.value = {
    descricao: descricaoSugeridaDespesa.value,
    subconta_id: '',
    forma_pagamento_id: '',
    observacao: observacao.value || ''
  }

  if (!subcontasDespesa.value.length || !formasPagamentoDespesa.value.length) {
    await carregarListasDespesa()
  }
}

function cancelarFormCriarDespesa() {
  mostrarFormCriarDespesa.value = false
  mostrarConfirmacaoCriarDespesa.value = false
}

function abrirConfirmacaoCriarDespesa() {
  if (!podeConfirmarCriacaoDespesa.value) {
    erro.value = 'Informe a descrição, a subconta e a forma de pagamento da despesa.'
    return
  }

  erro.value = ''
  mostrarConfirmacaoCriarDespesa.value = true
}

function cancelarConfirmacaoCriarDespesa() {
  mostrarConfirmacaoCriarDespesa.value = false
}

async function confirmarCriarDespesaEConciliar() {
  if (!podeCriarDespesaConciliar.value) return

  if (!podeConfirmarCriacaoDespesa.value) {
    erro.value = 'Informe a descrição, a subconta e a forma de pagamento da despesa.'
    return
  }

  salvando.value = true
  erro.value = ''

  try {
    await criarDespesaEConciliar({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,
      descricao: novaDespesa.value.descricao.trim(),
      subconta_id: Number(novaDespesa.value.subconta_id),
      forma_pagamento_id: Number(novaDespesa.value.forma_pagamento_id),
      observacao: novaDespesa.value.observacao || null,
      confirmar_criacao: true
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao criar despesa e realizar conciliação.'
  } finally {
    salvando.value = false
    mostrarConfirmacaoCriarDespesa.value = false
  }
}

function abrirRevisao(tipo) {
  erro.value = ''

  const validacaoCheque = validarSelecaoCompletaChequesFisicos()
  if (!validacaoCheque.valido) {
    erro.value = `O cheque ${validacaoCheque.cheque} está dividido em mais de um lançamento. Selecione todos os pagamentos do mesmo cheque antes de continuar.`
    return
  }

  if (tipo === 'consolidado') {
    if (!candidatoConsolidadoSelecionado.value) {
      erro.value = 'Selecione um único lançamento consolidado.'
      return
    }

    if (!podeConfirmarConsolidado.value) {
      erro.value = 'O saldo disponível do lançamento é insuficiente para este item.'
      return
    }
  } else {
    if (!selecionados.value.length || !podeConfirmar.value) {
      return
    }
  }

  if (tipo === 'normal' && temSelecionadoComAjuste.value) {
    erro.value = 'Este lançamento precisa ser ajustado antes da conciliação.'
    return
  }

  revisaoTipo.value = tipo
  etapa.value = 'revisao'
}

function voltarParaSelecao() {
  etapa.value = 'selecao'
  revisaoTipo.value = null
}

async function confirmarConsolidado() {
  const cand = candidatoConsolidadoSelecionado.value

  if (!cand || !podeConfirmarConsolidado.value) return

  const valorUtilizado = Math.abs(Number(valorItem.value || 0))
  const saldoAntes = Math.abs(Number(cand.saldo_disponivel || 0))
  const saldoDepois = Number(
    Math.max(saldoAntes - valorUtilizado, 0).toFixed(2)
  )

  salvando.value = true
  erro.value = ''

  try {
    const origemTipo =
      String(props.origemTipo || '').toUpperCase()

    const tipoConciliacao =
      origemTipo === 'OPERADORA'
        ? 'OPERADORA_SISTEMA'
        : 'BANCO_SISTEMA'

    await conciliarConsolidado({
      origem_item_tipo: origemTipo,
      origem_item_id: Number(props.item.id),
      tipo_conciliacao: tipoConciliacao,
      movimento_sistema_tabela: cand.origem_tabela,
      movimento_sistema_id: Number(cand.origem_id),
      valor_utilizado: valorUtilizado,
      observacao:
        observacao.value ||
        [
          origemTipo === 'OPERADORA'
            ? `Conciliação parcial Operadora x Sistema de ${formatCurrency(valorUtilizado)}.`
            : `Conciliação parcial de ${formatCurrency(valorUtilizado)}.`,
          `Lançamento original: ${formatCurrency(cand.valor)}.`,
          `Saldo antes: ${formatCurrency(saldoAntes)}.`,
          `Saldo após: ${formatCurrency(saldoDepois)}.`
        ].join(' ')
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value =
      e?.response?.data?.error ||
      'Erro ao salvar conciliação parcial.'
  } finally {
    salvando.value = false
  }
}

function abrirConfirmacaoAjustePix() {
  if (!candidatoComAjusteSelecionado.value || !podeAjustarConciliar.value) return

  erro.value = ''
  mostrarConfirmacaoAjustePix.value = true
}

function cancelarConfirmacaoAjustePix() {
  mostrarConfirmacaoAjustePix.value = false
}

async function confirmarComAjuste() {
  const cand = candidatoComAjusteSelecionado.value

  if (!cand || !podeAjustarConciliar.value) return

  salvando.value = true
  erro.value = ''

  try {
    await conciliarComAjuste({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,
      movimento_sistema_tabela: cand.origem_tabela,
      movimento_sistema_id: cand.origem_id,
      observacao: observacao.value || null,
      confirmar_ajuste: true
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao ajustar pagamento e realizar conciliação.'
  } finally {
    salvando.value = false
    mostrarConfirmacaoAjustePix.value = false
  }
}

function abrirConfirmacaoCriarReceita() {
  if (!podeConfirmarCriacaoReceita.value) {
    erro.value = 'Informe a descrição e a subconta da receita.'
    return
  }

  erro.value = ''
  mostrarConfirmacaoCriarReceita.value = true
}

function cancelarConfirmacaoCriarReceita() {
  mostrarConfirmacaoCriarReceita.value = false
}

async function confirmarCriarReceitaEConciliar() {
  if (!podeCriarReceitaConciliar.value) return

  if (!podeConfirmarCriacaoReceita.value) {
    erro.value = 'Informe a descrição e a subconta da receita.'
    return
  }

  salvando.value = true
  erro.value = ''

  try {
    await criarReceitaEConciliar({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,
      descricao: novaReceita.value.descricao.trim(),
      subconta_id: Number(novaReceita.value.subconta_id),
      observacao: novaReceita.value.observacao || null,
      confirmar_criacao: true
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao criar receita e realizar conciliação.'
  } finally {
    salvando.value = false
    mostrarConfirmacaoCriarReceita.value = false
  }
}

async function abrirFormCriarReceitaAbatimento() {
  if (!podeCriarReceitaAbatimento.value) return

  tratamentoDiferencaComposta.value = 'ABATIMENTO'

  erro.value = ''
  erroComposta.value = ''
  mostrarFormCriarReceitaAbatimento.value = true
  mostrarConfirmacaoCriarReceitaAbatimento.value = false

  despesasSelecionadasComposta.value = selecionados.value.filter((item) =>
    String(item?.tipo || '').toUpperCase() === 'DESPESA' ||
    String(item?.origem_tabela || '') === 'despesas_pagamentos'
  )

  novaReceitaAbatimento.value = {
    descricao: descricaoSugeridaReceitaAbatimento.value,
    subconta_id: '',
    observacao: observacao.value || ''
  }

  if (!subcontasReceita.value.length) {
    await carregarSubcontasReceita()
  }
}

function cancelarFormCriarReceitaAbatimento() {
  mostrarFormCriarReceitaAbatimento.value = false
  mostrarConfirmacaoCriarReceitaAbatimento.value = false
}

function abrirConfirmacaoCriarReceitaAbatimento() {
  if (!podeConfirmarCriacaoReceitaAbatimento.value) {
    erroComposta.value = 'Informe a descrição e a subconta da receita de abatimento.'
    return
  }

  erroComposta.value = ''
  mostrarConfirmacaoCriarReceitaAbatimento.value = true
}

function cancelarConfirmacaoCriarReceitaAbatimento() {
  mostrarConfirmacaoCriarReceitaAbatimento.value = false
}

async function confirmarCriarReceitaAbatimentoEConciliar() {
  if (!podeConfirmarCriacaoReceitaAbatimento.value) {
    erroComposta.value = 'Informe a descrição e a subconta da receita de abatimento.'
    return
  }

  salvando.value = true
  erro.value = ''
  erroComposta.value = ''

  try {
    await criarReceitaAbatimentoEConfirmarComposta({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,

      receitas: receitasSelecionadasComposta.value.map((item) => ({
        tabela: item.origem_tabela,
        id: item.origem_id,
        papel: 'ABATE',
        valor_utilizado: getValorOriginalComposta(item)
      })),

      despesas: despesasSelecionadasComposta.value.map((item) => ({
        tabela: item.origem_tabela,
        id: item.origem_id,
        papel: 'COMPOE',
        valor_utilizado: getValorOriginalComposta(item)
      })),

      descricao: novaReceitaAbatimento.value.descricao.trim(),
      subconta_id: Number(novaReceitaAbatimento.value.subconta_id),
      observacao: novaReceitaAbatimento.value.observacao || null,
      confirmar_criacao: true
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erroComposta.value =
      e?.response?.data?.error ||
      'Erro ao criar receita de abatimento e confirmar conciliação.'
  } finally {
    salvando.value = false
    mostrarConfirmacaoCriarReceitaAbatimento.value = false
  }
}

function chaveComposta(item) {
  if (!item) return ''

  const tabela = String(item.origem_tabela || item.movimento_sistema_tabela || '')
  const id = item.origem_id || item.movimento_sistema_id || item.id || ''

  if (!tabela || !id) return ''

  return `${tabela}-${id}`
}

function getValorOriginalComposta(item) {
  if (!item) return 0

  return Math.abs(Number(item.valor || item.valor_utilizado || 0))
}

function normalizarCandidatoComposicaoSugerida(item) {
  return {
    origem_tabela: item.origem_tabela,
    origem_id: item.origem_id,
    descricao: item.descricao || item.origem_tabela,
    valor: Number(item.valor || 0),
    data: item.data || item.dt_caixa || null,
    dt_caixa: item.data || item.dt_caixa || null,
    forma_pagamento_nome: item.forma_pagamento_nome || null,
    tipo: Number(item.valor || 0) >= 0 ? 'RECEITA' : 'DESPESA',
    origem_sugestao: 'MOVIMENTACOES_DIARIAS'
  }
}

function parseValorMonetarioInput(valor) {
  if (valor == null || valor === '') return 0

  const texto = String(valor).trim()

  if (!texto) return 0

  if (texto.includes(',')) {
    return Number(
      texto
        .replace(/\./g, '')
        .replace(',', '.')
    )
  }

  return Number(texto)
}

function formatValorMonetarioInput(valor) {
  const numero = Number(valor || 0)

  if (!Number.isFinite(numero)) return ''

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numero)
}

function getAjustePagamentoKey(item) {
  return chaveComposta(item)
}

function getAjustePagamento(item) {
  const key = getAjustePagamentoKey(item)

  if (!key) {
    return {
      juros: '0,00',
      multa: '0,00',
      desconto: '0,00',
      observacao: ''
    }
  }

  return ajustesPagamentosComposta.value[key] || {
    juros: '0,00',
    multa: '0,00',
    desconto: '0,00',
    observacao: ''
  }
}

function setAjustePagamentoCampo(item, campo, valor) {
  const key = getAjustePagamentoKey(item)
  if (!key) return

  const atual = getAjustePagamento(item)

  ajustesPagamentosComposta.value = {
    ...ajustesPagamentosComposta.value,
    [key]: {
      ...atual,
      [campo]: valor
    }
  }
}

function onBlurAjustePagamentoCampo(item, campo) {
  const atual = getAjustePagamento(item)
  const valor = parseValorMonetarioInput(atual[campo])

  setAjustePagamentoCampo(item, campo, formatValorMonetarioInput(valor))
}

function getJurosPagamentoComposta(item) {
  return Math.abs(parseValorMonetarioInput(getAjustePagamento(item).juros))
}

function getMultaPagamentoComposta(item) {
  return Math.abs(parseValorMonetarioInput(getAjustePagamento(item).multa))
}

function getDescontoPagamentoComposta(item) {
  return Math.abs(parseValorMonetarioInput(getAjustePagamento(item).desconto))
}

function getValorLiquidoPagamentoComposta(item) {
  const valorOriginal = getValorOriginalComposta(item)
  const juros = getJurosPagamentoComposta(item)
  const multa = getMultaPagamentoComposta(item)
  const desconto = getDescontoPagamentoComposta(item)

  return Number((valorOriginal + juros + multa - desconto).toFixed(2))
}

function montarDespesasAjustadasPayload() {
  return despesasSelecionadasComposta.value.map((item) => {
    const ajuste = getAjustePagamento(item)

    return {
      tabela: item.origem_tabela,
      id: item.origem_id,
      papel: 'COMPOE',
      juros: getJurosPagamentoComposta(item),
      multa: getMultaPagamentoComposta(item),
      desconto: getDescontoPagamentoComposta(item),
      observacao: ajuste.observacao || null
    }
  })
}

function inicializarAjustesPagamentosComposta() {
  const novos = { ...ajustesPagamentosComposta.value }

  despesasSelecionadasComposta.value.forEach((item) => {
    const key = getAjustePagamentoKey(item)

    if (!key) return

    if (!novos[key]) {
      novos[key] = {
        juros: '0,00',
        multa: '0,00',
        desconto: '0,00',
        observacao: ''
      }
    }
  })

  ajustesPagamentosComposta.value = novos
}

function escolherCorrigirValorLancamento() {
  tratamentoDiferencaComposta.value = 'AJUSTAR_PAGAMENTO'

  despesasSelecionadasComposta.value = selecionados.value.filter((item) =>
    String(item?.tipo || '').toUpperCase() === 'DESPESA' ||
    String(item?.origem_tabela || '') === 'despesas_pagamentos'
  )

  inicializarAjustesPagamentosComposta()
}

async function escolherLancamentoAbatimento() {
  tratamentoDiferencaComposta.value = 'ABATIMENTO'

  if (isPagamentoConsolidadoBanco.value) {
    await carregarCandidatosAbatimentoPagamentoConsolidado()
  }
}

async function carregarCandidatosAbatimentoPagamentoConsolidado() {
  if (!isPagamentoConsolidadoBanco.value) return

  carregandoComposta.value = true
  erroComposta.value = ''
  mostrarConciliacaoComposta.value = true

  despesasSelecionadasComposta.value = selecionados.value.filter((item) =>
    String(item?.tipo || '').toUpperCase() === 'DESPESA' ||
    String(item?.origem_tabela || '') === 'despesas_pagamentos'
  )

  receitasSelecionadasComposta.value = []

  try {
    const { data } = await listarCandidatosConciliacaoComposta({
      origemTipo: props.origemTipo,
      origemItemId: props.item.id,
      dataInicio: props.dataInicio || undefined,
      dataFim: props.dataFim || undefined
    })

    candidatosCompostaReceitas.value = Array.isArray(data?.receitas)
      ? data.receitas
      : []

    candidatosCompostaDespesas.value = Array.isArray(data?.despesas)
      ? data.despesas
      : []
  } catch (e) {
    erroComposta.value =
      e?.response?.data?.error ||
      'Erro ao carregar receitas de abatimento.'

    candidatosCompostaReceitas.value = []
    candidatosCompostaDespesas.value = []
  } finally {
    carregandoComposta.value = false
  }
}

async function confirmarComposta() {
  if (!podeConfirmarComposicaoOuAjuste.value) return

  salvando.value = true
  erro.value = ''
  erroComposta.value = ''

  try {
    const isDebito = isOfxDebito.value
    const isCredito = isOfxCredito.value

    if (tratamentoDiferencaComposta.value === 'AJUSTAR_PAGAMENTO') {
      await ajustarPagamentosEConfirmarComposta({
        origem_item_tipo: props.origemTipo,
        origem_item_id: props.item.id,

        receitas: receitasSelecionadasComposta.value.map((item) => ({
          tabela: item.origem_tabela,
          id: item.origem_id,
          papel: isCredito ? 'COMPOE' : 'ABATE',
          valor_utilizado: getValorOriginalComposta(item)
        })),

        despesas: montarDespesasAjustadasPayload(),

        observacao: observacao.value || null,
        confirmar_ajuste: true
      })

      emit('salvo')
      emit('close')
      return
    }    

    await confirmarConciliacaoComposta({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,

      receitas: receitasSelecionadasComposta.value.map((item) => ({
        tabela: item.origem_tabela,
        id: item.origem_id,
        papel: isCredito ? 'COMPOE' : 'ABATE',
        valor_utilizado: getValorOriginalComposta(item)
      })),

      despesas: despesasSelecionadasComposta.value.map((item) => ({
        tabela: item.origem_tabela,
        id: item.origem_id,
        papel: isDebito ? 'COMPOE' : 'ABATE',
        valor_utilizado: getValorOriginalComposta(item)
      })),

      observacao: observacao.value || null,
      confirmar: true
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value =
      e?.response?.data?.error ||
      'Erro ao confirmar conciliação composta.'
  } finally {
    salvando.value = false
  }
}

async function confirmar() {
  if (!selecionados.value.length || !podeConfirmar.value) return

  const validacaoCheque = validarSelecaoCompletaChequesFisicos()
  if (!validacaoCheque.valido) {
    erro.value = `O cheque ${validacaoCheque.cheque} está dividido em mais de um lançamento. Selecione todos os pagamentos do mesmo cheque.`
    etapa.value = 'selecao'
    revisaoTipo.value = null
    return
  }

  salvando.value = true
  erro.value = ''

  try {
    await conciliarManual({
      origem_item_tipo: props.origemTipo,
      origem_item_id: props.item.id,
      tipo_conciliacao: props.origemTipo === 'OFX' ? 'BANCO_SISTEMA' : 'OPERADORA_SISTEMA',
      movimentos: selecionados.value.map((item) => ({
        movimento_sistema_tabela: item.origem_tabela,
        movimento_sistema_id: item.origem_id,
        tipo_vinculo_sugerido: item.tipo_vinculo_sugerido || null,
        valor_utilizado: Math.abs(Number(getValorConsideradoConciliacao(item) || 0))
      })),
      observacao: observacao.value || null
    })

    emit('salvo')
    emit('close')
  } catch (e) {
    erro.value = e?.response?.data?.error || 'Erro ao salvar conciliação.'
  } finally {
    salvando.value = false
  }
}

function isReceitaCompostaSelecionada(item) {
  return receitasSelecionadasComposta.value.some(
    (selecionado) => chaveComposta(selecionado) === chaveComposta(item)
  )
}

function isDespesaCompostaSelecionada(item) {
  return despesasSelecionadasComposta.value.some(
    (selecionado) => chaveComposta(selecionado) === chaveComposta(item)
  )
}

function toggleReceitaComposta(item) {
  if (isReceitaCompostaSelecionada(item)) {
    receitasSelecionadasComposta.value = receitasSelecionadasComposta.value.filter(
      (selecionado) => chaveComposta(selecionado) !== chaveComposta(item)
    )
    return
  }

  receitasSelecionadasComposta.value = [
    ...receitasSelecionadasComposta.value,
    item
  ]
}

function toggleDespesaComposta(item) {
  if (isDespesaCompostaSelecionada(item)) {
    despesasSelecionadasComposta.value = despesasSelecionadasComposta.value.filter(
      (selecionado) => chaveComposta(selecionado) !== chaveComposta(item)
    )
    return
  }

  despesasSelecionadasComposta.value = [
    ...despesasSelecionadasComposta.value,
    item
  ]
}

function abrirRevisaoConciliacaoComposta() {
  if (isPagamentoConsolidadoBanco.value) {
    despesasSelecionadasComposta.value = selecionados.value.filter((item) =>
      String(item?.tipo || '').toUpperCase() === 'DESPESA' ||
      String(item?.origem_tabela || '') === 'despesas_pagamentos'
    )
  }

  if (!podeConfirmarComposicaoOuAjuste.value) return

  erroComposta.value = ''
  revisaoTipo.value = 'composta'
  etapa.value = 'revisao'
}

function normalizarNumeroChequeFrontend(valor) {
  const numeros = String(valor || '').replace(/\D/g, '')
  if (!numeros) return ''
  return numeros.replace(/^0+(?=\d)/, '')
}

function chaveChequeFisico(item) {
  if (!item) return ''
  if (item.chave_cheque_fisico) return String(item.chave_cheque_fisico)

  const cheque = normalizarNumeroChequeFrontend(
    item.cheque_numero_normalizado || item.cheque_numero || item.cheque_evento_cheque_numero
  )
  if (!cheque) return ''

  return [
    item.origem_tabela === 'pagamentos_matriculas' ? 'PAGAMENTO_MATRICULA' : String(item.origem_tabela || ''),
    item.responsavel_id || '',
    item.banco_numero || '',
    item.agencia || '',
    cheque
  ].join('|')
}

function candidatosDoMesmoChequeFisico(item) {
  const chaveFisica = chaveChequeFisico(item)
  if (!chaveFisica) return [item]
  const relacionados = (candidatos.value || []).filter((cand) => chaveChequeFisico(cand) === chaveFisica)
  return relacionados.length ? relacionados : [item]
}

function chequeFisicoPossuiMaisDeUmLancamento(item) {
  return candidatosDoMesmoChequeFisico(item).length > 1
}

function isPrimeiroCandidatoDoCheque(item) {
  const grupo = candidatosDoMesmoChequeFisico(item)
  return !grupo.length || chave(grupo[0]) === chave(item)
}

function validarSelecaoCompletaChequesFisicos() {
  const selecionadosCheque = selecionados.value.filter((item) => {
    const tipo = String(item?.tipo_vinculo || item?.tipo_vinculo_sugerido || '').toUpperCase()
    return ['CHEQUE_DEPOSITO_AGRUPADO', 'CHEQUE_DEVOLVIDO', 'CHEQUE_REAPRESENTADO'].includes(tipo)
  })

  for (const selecionado of selecionadosCheque) {
    const grupoCompleto = candidatosDoMesmoChequeFisico(selecionado)
    if (grupoCompleto.length <= 1) continue

    const idsSelecionados = new Set(selecionados.value.map((item) => chave(item)))
    const faltantes = grupoCompleto.filter((item) => !idsSelecionados.has(chave(item)))

    if (faltantes.length) {
      return {
        valido: false,
        cheque: selecionado.cheque_numero || selecionado.cheque_numero_normalizado || 'não informado',
        quantidadeFaltante: faltantes.length
      }
    }
  }

  return { valido: true, cheque: null, quantidadeFaltante: 0 }
}

function chave(item) {
  return `${item.origem_tabela}-${item.origem_id}`
}

function isSelecionado(item) {
  return selecionados.value.some((s) => chave(s) === chave(item))
}

function isOperadoraAutorizacaoAgrupada(item) {
  return (
    item?.candidato_agrupado_operadora === true ||
    String(
      item?.tipo_vinculo ||
      item?.tipo_vinculo_sugerido ||
      ''
    ).toUpperCase() === 'OPERADORA_AUTORIZACAO_AGRUPADA'
  )
}

function candidatosDoMesmoGrupoOperadora(item) {
  if (!isOperadoraAutorizacaoAgrupada(item)) {
    return [item]
  }

  const grupo = String(
    item?.grupo_autorizacao_composta ||
    item?.numero_autorizacao ||
    ''
  )
    .trim()
    .toUpperCase()

  if (!grupo) {
    return [item]
  }

  const relacionados = (candidatos.value || []).filter((cand) => {
    if (!isOperadoraAutorizacaoAgrupada(cand)) {
      return false
    }

    const grupoCand = String(
      cand?.grupo_autorizacao_composta ||
      cand?.numero_autorizacao ||
      ''
    )
      .trim()
      .toUpperCase()

    return grupoCand === grupo
  })

  return relacionados.length
    ? relacionados
    : [item]
}

function toggleSelecionado(item) {
  mostrarConfirmacaoAjustePix.value = false
  erro.value = ''

  const itemEhConsolidado =
    isConsolidadoParcial(item)

  const itemEhOperadoraAgrupada =
    isOperadoraAutorizacaoAgrupada(item)

  const jaSelecionado =
    isSelecionado(item)

  const tipoVinculo = String(
    item?.tipo_vinculo ||
    item?.tipo_vinculo_sugerido ||
    ''
  ).toUpperCase()

  const itemEhChequeComControleDeGrupo = [
    'CHEQUE_DEPOSITO_AGRUPADO',
    'CHEQUE_DEVOLVIDO',
    'CHEQUE_REAPRESENTADO'
  ].includes(tipoVinculo)

  const grupoCheque =
    itemEhChequeComControleDeGrupo
      ? candidatosDoMesmoChequeFisico(item)
      : [item]

  const grupoOperadora =
    itemEhOperadoraAgrupada
      ? candidatosDoMesmoGrupoOperadora(item)
      : [item]

  const grupoSelecao =
    itemEhChequeComControleDeGrupo
      ? grupoCheque
      : itemEhOperadoraAgrupada
        ? grupoOperadora
        : [item]

  const chavesGrupo =
    new Set(
      grupoSelecao.map((cand) => chave(cand))
    )

  if (jaSelecionado) {
    selecionados.value =
      selecionados.value.filter(
        (selecionado) =>
          !chavesGrupo.has(chave(selecionado))
      )

    if (
      itemEhChequeComControleDeGrupo &&
      grupoSelecao.length > 1
    ) {
      aviso.value =
        `Os ${grupoSelecao.length} lançamentos do cheque ${item.cheque_numero || item.cheque_numero_normalizado || 'informado'} foram removidos juntos.`
    } else if (
      itemEhOperadoraAgrupada &&
      grupoSelecao.length > 1
    ) {
      aviso.value =
        `Os ${grupoSelecao.length} lançamentos da autorização agrupada foram removidos juntos.`
    }

    if (etapa.value === 'revisao') {
      voltarParaSelecao()
    }

    return
  }

  if (itemEhConsolidado) {
    selecionados.value = [item]
  } else {
    const possuiConsolidadoSelecionado =
      selecionados.value.some(
        isConsolidadoParcial
      )

    if (possuiConsolidadoSelecionado) {
      selecionados.value =
        [...grupoSelecao]
    } else {
      const mapaSelecionados =
        new Map(
          selecionados.value.map(
            (selecionado) => [
              chave(selecionado),
              selecionado
            ]
          )
        )

      for (const cand of grupoSelecao) {
        mapaSelecionados.set(
          chave(cand),
          cand
        )
      }

      selecionados.value =
        Array.from(
          mapaSelecionados.values()
        )
    }
  }

  if (
    itemEhChequeComControleDeGrupo &&
    grupoSelecao.length > 1
  ) {
    aviso.value =
      `O cheque ${item.cheque_numero || item.cheque_numero_normalizado || 'informado'} está dividido em ${grupoSelecao.length} lançamentos. Todos foram selecionados juntos.`
  } else if (
    itemEhOperadoraAgrupada &&
    grupoSelecao.length > 1
  ) {
    const autorizacao =
      item?.grupo_autorizacao_composta ||
      item?.numero_autorizacao ||
      'informada'

    aviso.value =
      `A autorização composta ${autorizacao} possui ${grupoSelecao.length} lançamentos. Todos foram selecionados juntos.`
  }

  if (etapa.value === 'revisao') {
    voltarParaSelecao()
  }
}

function isChequeDevolvido(item) {
  return String(item?.tipo_vinculo || item?.tipo_vinculo_sugerido || '').toUpperCase() === 'CHEQUE_DEVOLVIDO'
}

function isDepositoChequeAgrupado(item) {
  return String(item?.tipo_vinculo || item?.tipo_vinculo_sugerido || '').toUpperCase() === 'CHEQUE_DEPOSITO_AGRUPADO'
}

function isChequeReapresentado(item) {
  return String(item?.tipo_vinculo || item?.tipo_vinculo_sugerido || '').toUpperCase() === 'CHEQUE_REAPRESENTADO'
}

function getValorConsideradoConciliacao(item) {
  const tipo = String(
    item?.tipo_vinculo ||
    item?.tipo_vinculo_sugerido ||
    ''
  ).toUpperCase()

  if (isConsolidadoParcial(item)) {
    return Math.abs(
      Number(
        item?.valor_item_banco ??
        props.item?.valor ??
        item?.valor_utilizado ??
        0
      )
    )
  }

  if (
    tipo === 'CHEQUE_DEVOLVIDO' ||
    tipo === 'CHEQUE_REAPRESENTADO' ||
    tipo === 'CHEQUE_DEPOSITO_AGRUPADO'
  ) {
    return Math.abs(
      Number(
        item?.valor_utilizado ??
        item?.cheque_evento_valor ??
        item?.valor ??
        0
      )
    )
  }

  if (item?.valor_utilizado != null) {
    return Number(item.valor_utilizado)
  }

  return Number(item?.valor || 0)
}

function getDataConsideradaConciliacao(item) {
  if (isChequeReapresentado(item)) {
    return item?.cheque_evento_data || item?.cheque_data_reapresentacao || props.item?.dt_movimento || item?.dt_caixa
  }

  if (isChequeDevolvido(item)) {
    return item?.cheque_evento_data || item?.cheque_data_devolucao || item?.dt_caixa
  }

  return item?.dt_caixa
}

function chequeFoiDevolvidoDepoisDoDeposito(item) {
  return Boolean(item?.cheque_data_devolucao)
}

function chequeFoiReapresentado(item) {
  return Boolean(item?.cheque_data_reapresentacao)
}

function isConsolidadoParcial(item) {
  return (
    item?.candidato_consolidado === true ||
    String(
      item?.tipo_vinculo ||
      item?.tipo_vinculo_sugerido ||
      ''
    ).toUpperCase() === 'CONSOLIDADO_PARCIAL'
  )
}

function isPixPessoaIdentificada(item) {
  return String(item?.tipo_candidato || '').toUpperCase() === 'PIX_PESSOA_IDENTIFICADA'
}

function isPixAjusteNecessario(item) {
  return (
    isPixPessoaIdentificada(item) &&
    (
      Boolean(item?.ajuste_necessario) ||
      String(item?.tipo_vinculo_sugerido || '').toUpperCase() === 'PIX_AJUSTE_NECESSARIO'
    )
  )
}

function getAlunosPixVinculados(item) {
  const listasPossiveis = [
    item?.pix_alunos_vinculados,
    item?.pix_matriculas_vinculadas,
    item?.pix_pessoa_alunos,
    item?.alunos_vinculados
  ]

  for (const lista of listasPossiveis) {
    if (Array.isArray(lista) && lista.length) {
      return lista
        .map((aluno) => ({
          matricula_id: aluno.matricula_id || aluno.id_matricula || aluno.id || null,
          aluno_nome: aluno.aluno_nome || aluno.nome_aluno || aluno.nome || '',
          tipo_vinculo: aluno.tipo_vinculo || aluno.vinculo || null
        }))
        .filter((aluno) => aluno.aluno_nome)
    }
  }

  return []
}

function temAlunosPixVinculados(item) {
  return getAlunosPixVinculados(item).length > 0
}

function temDivergencias(item) {
  const divergencias = item?.divergencias || {}
  return Object.values(divergencias).some(Boolean)
}

function listarDivergencias(item) {
  const divergencias = item?.divergencias || {}
  const lista = []

  if (divergencias.valor) lista.push('Valor diferente')
  if (divergencias.data) lista.push('Data diferente')
  if (divergencias.forma_pagamento) lista.push('Forma diferente')
  if (divergencias.a_informar) lista.push('A informar')
  if (divergencias.cheque) lista.push('Cheque')

  return lista
}

function formatarPapelConciliacaoComposta(tipoVinculo) {
  const key = String(tipoVinculo || '').toUpperCase()

  const isDebitoBanco = Number(props.item?.valor || 0) < 0
  const isCreditoBanco = Number(props.item?.valor || 0) > 0

  if (key === 'DESPESA_COMPOE_CONCILIACAO') {
    return isDebitoBanco ? 'Compõe o pagamento' : 'Despesa vinculada'
  }

  if (key === 'RECEITA_ABATE_CONCILIACAO') {
    return isDebitoBanco ? 'Abate o pagamento' : 'Receita vinculada'
  }

  if (key === 'RECEITA_COMPOE_CONCILIACAO') {
    return isCreditoBanco ? 'Compõe o recebimento' : 'Receita vinculada'
  }

  if (key === 'DESPESA_ABATE_CONCILIACAO') {
    return isCreditoBanco ? 'Abate o recebimento' : 'Despesa vinculada'
  }

  return 'Composição'
}

function formatarOrigemTaxa(valor) {
  const key = String(valor || '').toUpperCase()

  if (key === 'CONCILIADO_MANUAL') return 'Conciliado manual'
  if (key === 'CONCILIADO_AUTOMATICO') return 'Conciliado automático'

  return valor || '—'
}

function formatChequeStatus(status) {
  const key = String(status || '').toUpperCase()

  const map = {
    NORMAL: 'Normal',
    DEVOLVIDO: 'Devolvido',
    REAPRESENTADO: 'Reapresentado',
    COMPENSADO: 'Compensado',
    SUBSTITUIDO: 'Substituído'
  }

  return map[key] || status || '—'
}

function formatDate(v) {
  if (!v) return '—'

  const s = String(v).trim()

  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.slice(0, 10).split('-')
    return `${d}/${m}/${y}`
  }

  const dt = new Date(s)
  if (Number.isNaN(dt.getTime())) return '—'

  const y = dt.getFullYear()
  const m = String(dt.getMonth() + 1).padStart(2, '0')
  const d = String(dt.getDate()).padStart(2, '0')
  return `${d}/${m}/${y}`
}

function formatCurrency(v) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(v || 0))
}

function autoSelecionarLoteChequeAgrupado() {
  const candidatosCheque = (candidatos.value || []).filter((cand) =>
    cand?.deposito_cheque_agrupado === true &&
    cand?.candidato_agrupado_cheque === true &&
    cand?.deposito_cheque_parcial === false
  )

  if (!candidatosCheque.length) return

  const bloqueiaSelecaoAutomatica = candidatosCheque.some((cand) =>
    cand?.deposito_cheque_auto_selecionar === false ||
    String(cand?.tipo_candidato || '').toUpperCase() === 'DEPOSITO_CHEQUE_MULTIPLAS_COMBINACOES'
  )

  if (bloqueiaSelecaoAutomatica) {
    selecionados.value = []
    return
  }

  const composicaoConfiavel = candidatosCheque.every((cand) =>
    cand?.deposito_cheque_combinacao_confiavel === true ||
    cand?.deposito_cheque_auto_selecionar === true
  )

  if (!composicaoConfiavel) {
    selecionados.value = []
    return
  }

  const total = candidatosCheque.reduce((acc, cand) => {
    return acc + Math.abs(Number(getValorConsideradoConciliacao(cand) || 0))
  }, 0)

  selecionados.value = Math.abs(total - valorItem.value) <= 0.01
    ? [...candidatosCheque]
    : []
}

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 1100px;
  max-height: 92vh;
  margin: 0 10px;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  background: #f3f4f6;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid #ced4da;
}

.modal-subtitle {
  color: #6b7280;
  font-size: 0.78rem;
}

.modal-content {
  padding: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
}

.modal-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ced4da;
  flex-shrink: 0;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.conciliation-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.summary-card {
  border: 1px solid #d1d5db;
  background: #fff;
  padding: 12px;
  min-height: 96px;
}

.summary-card__label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 4px;
}

.summary-card__value {
  font-size: 1.25rem;
  font-weight: 800;
  color: #111827;
}

.summary-card__meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 2px;
}

.summary-card__memo {
  margin-top: 6px;
  font-size: 0.78rem;
  color: #374151;
  line-height: 1.25;
  font-weight: 600;
  word-break: break-word;
}

.summary-card--source {
  background: #f8fafc;
}

.summary-card--ok {
  border-color: #86efac;
  background: #f0fdf4;
}

.summary-card--tolerated {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.summary-card--alert {
  border-color: #fecaca;
  background: #fef2f2;
}

.flow-steps {
  display: flex;
  gap: 8px;
  align-items: center;
}

.flow-step {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d1d5db;
  color: #6b7280;
  background: #fff;
  padding: 5px 10px;
  font-size: 0.8rem;
  font-weight: 600;
}

.flow-step span {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  color: #374151;
  font-size: 0.72rem;
}

.flow-step.active {
  border-color: #93c5fd;
  color: #1d4ed8;
  background: #eff6ff;
}

.flow-step.active span {
  background: #1d4ed8;
  color: #fff;
}

.flow-step.done {
  border-color: #86efac;
  color: #166534;
  background: #f0fdf4;
}

.flow-step.done span {
  background: #16a34a;
  color: #fff;
}

.info-box {
  border: 1px solid #ced4da;
  padding: 10px 12px;
  background: #f8f9fa;
}

.cheque-devolvido-box {
  border-color: #fecaca;
  background: #fef2f2;
}

.cheque-reapresentado-box {
  border-color: #fde68a;
  background: #fffbeb;
}

.deposito-cheque-box {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.deposito-cheque-resumo {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.deposito-cheque-resumo > div {
  border: 1px solid #dbeafe;
  background: #fff;
  padding: 8px 10px;
}

.deposito-cheque-resumo span,
.deposito-cheque-grid span {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.deposito-cheque-lista {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.deposito-cheque-item {
  border: 1px solid #dbeafe;
  background: #fff;
  padding: 10px 12px;
}

.deposito-cheque-item__main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.deposito-cheque-item__valor {
  font-weight: 800;
  white-space: nowrap;
}

.deposito-cheque-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.deposito-cheque-grid > div {
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 7px 9px;
}

.deposito-cheque-observacao {
  border-left: 3px solid #93c5fd;
  background: #f8fafc;
  padding: 7px 9px;
  font-size: 0.8rem;
}

.section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.selection-counter {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1d4ed8;
  background: #dbeafe;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.table-scroll {
  max-height: 340px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ced4da;
}

.table {
  margin-bottom: 0;
}

.table th {
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  font-size: 0.83rem;
  vertical-align: middle;
}

.row-selected {
  outline: 2px solid #bfdbfe;
  outline-offset: -2px;
  background: #eff6ff;
}

.candidate-title {
  font-weight: 600;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0;
}

.review-panel {
  border: 1px solid #d1d5db;
  background: #f9fafb;
  padding: 14px;
}

.review-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 12px;
}

.review-title i {
  color: #16a34a;
}

.review-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.review-box {
  border: 1px solid #d1d5db;
  background: #fff;
  padding: 10px 12px;
}

.review-box__label {
  font-size: 0.76rem;
  font-weight: 800;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 8px;
}

.selected-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #e5e7eb;
  padding: 8px 0;
}

.selected-item:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.selected-item__value {
  font-weight: 800;
  white-space: nowrap;
}

.white-space-pre-line {
  white-space: pre-line;
}

.diff-ok {
  color: #166534;
  font-weight: 700;
}

.diff-alert {
  color: #b91c1c;
  font-weight: 700;
}

.diff-tolerated {
  color: #1d4ed8;
  font-weight: 700;
}

input[type="checkbox"] {
  transform: scale(0.85);
  transform-origin: center;
  cursor: pointer;
  margin: 0;
}

.modal-action-btn {
  font-size: 0.875rem;
  line-height: 1.2;
  padding: 0.375rem 0.75rem;
}

.status-badge {
  display: inline-block;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
}

.is-green {
  background: #dcfce7;
  color: #166534;
}

.is-gray {
  background: #e5e7eb;
  color: #374151;
}

.is-red {
  background: #fee2e2;
  color: #991b1b;
}

.is-amber {
  background: #fde68a;
  color: #92400e;
}

.pix-match-box {
  border-left: 3px solid #2563eb;
  background: #eff6ff;
  padding: 6px 8px;
  font-size: 0.76rem;
}

.pix-match-title {
  font-weight: 800;
  color: #1d4ed8;
  display: flex;
  align-items: center;
  gap: 5px;
}

.pix-match-text {
  color: #1f2937;
  margin-top: 2px;
}

.pix-alunos-vinculados {
  border-top: 1px solid #bfdbfe;
  padding-top: 6px;
}

.pix-alunos-title {
  font-size: 0.72rem;
  font-weight: 800;
  color: #1d4ed8;
  margin-bottom: 3px;
}

.pix-alunos-list {
  margin: 0;
  padding-left: 18px;
  color: #1f2937;
  font-size: 0.76rem;
}

.pix-alunos-list li {
  margin-bottom: 2px;
}

.pix-adjust-warning {
  color: #92400e;
  font-weight: 700;
}

.pix-divergences {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.divergence-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 2px 7px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.68rem;
  font-weight: 700;
}

.is-blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.is-orange {
  background: #ffedd5;
  color: #9a3412;
}

.pix-ajuste-detalhe-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.ajuste-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.ajuste-card {
  border: 1px solid #fed7aa;
  background: #fff;
  padding: 8px 10px;
}

.ajuste-card-title {
  font-weight: 800;
  color: #9a3412;
  margin-bottom: 6px;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.pix-sem-pessoa-alert {
  border-left: 4px solid #f59e0b;
}

.pix-pessoa-identificada-alert {
  border-left: 4px solid #2563eb;
}

.criar-receita-box {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.criar-receita-box .form-label {
  font-size: 0.76rem;
  font-weight: 700;
  margin-bottom: 3px;
}

.confirmar-criacao-receita-box {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.criar-despesa-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.criar-despesa-box .form-label {
  font-size: 0.76rem;
  font-weight: 700;
  margin-bottom: 3px;
}

.confirmar-criacao-despesa-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.confirmacao-receita-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.confirmacao-receita-grid > div,
.confirmacao-descricao {
  border: 1px solid #d1fae5;
  background: #fff;
  padding: 8px 10px;
}

.confirmacao-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.despesa-criada-detalhe-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.despesa-criada-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.despesa-criada-grid > div,
.despesa-criada-observacao {
  border: 1px solid #fed7aa;
  background: #fff;
  padding: 8px 10px;
}

.despesa-criada-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.receita-criada-detalhe-box {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.receita-criada-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.receita-criada-grid > div,
.receita-criada-pix,
.receita-criada-observacao {
  border: 1px solid #d1fae5;
  background: #fff;
  padding: 8px 10px;
}

.receita-criada-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.consolidado-parcial-detalhe-box {
  border-color: #fde68a;
  background: #fffbeb;
}

.conciliacao-composta-detalhe-box {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.composta-detalhe-resumo {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.composta-detalhe-resumo > div {
  border: 1px solid #dbeafe;
  background: #fff;
  padding: 8px 10px;
}

.composta-detalhe-resumo span {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.composta-detalhe-resumo strong {
  display: block;
  font-size: 0.95rem;
}

.composta-detalhe-lista {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.composta-detalhe-item {
  border: 1px solid #dbeafe;
  background: #fff;
  padding: 10px 12px;
}

.composta-detalhe-item__main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.composta-detalhe-item__valor {
  font-weight: 800;
  white-space: nowrap;
}

.composta-detalhe-observacao {
  border-left: 3px solid #93c5fd;
  background: #f8fafc;
  padding: 7px 9px;
  font-size: 0.8rem;
}

.confirmar-ajuste-pix-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.conciliacao-composta-start-box {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.conciliacao-composta-box {
  border-color: #bfdbfe;
  background: #f8fafc;
}

.composta-section-title {
  font-size: 0.78rem;
  font-weight: 800;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
}

.composta-table-scroll {
  max-height: 260px;
}

.composta-resumo {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.composta-resumo-card {
  border: 1px solid #d1d5db;
  background: #fff;
  padding: 10px 12px;
  min-height: 82px;
}

.composta-resumo-card span {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.composta-resumo-card strong {
  display: block;
  font-size: 1rem;
  color: #111827;
}

.composta-resumo-card small {
  display: block;
  margin-top: 3px;
  font-size: 0.72rem;
}

.composta-resumo-card--ok {
  border-color: #86efac;
  background: #f0fdf4;
}

.composta-resumo-card--alert {
  border-color: #fecaca;
  background: #fef2f2;
}

.ajuste-valor-composta-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.ajuste-valor-composta-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 10px;
}

.ajuste-valor-composta-grid > div {
  border: 1px solid #fed7aa;
  background: #fff;
  padding: 8px 10px;
}

.ajuste-valor-composta-grid span {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.tratar-diferenca-composta-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.receita-abatimento-box {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.receita-abatimento-box .form-label {
  font-size: 0.76rem;
  font-weight: 700;
  margin-bottom: 3px;
}

.receita-abatimento-detalhe-box {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.ajuste-pagamento-composta-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.ajuste-pagamento-detalhe-box {
  border-color: #fed7aa;
  background: #fff7ed;
}

.ajuste-pagamento-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.ajuste-pagamento-grid > div,
.ajuste-pagamento-observacao {
  border: 1px solid #fed7aa;
  background: #fff;
  padding: 8px 10px;
}

.ajuste-pagamento-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 2px;
}


.cheque-evento-posterior {
  border-left: 3px solid #16a34a;
  background: #f0fdf4;
  padding: 6px 8px;
  font-size: 0.74rem;
  color: #166534;
}

.cheque-evento-posterior__title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 800;
  margin-bottom: 2px;
}

.cheque-combinacao-motivos {
  border-left: 3px solid #2563eb;
  background: #eff6ff;
  padding: 6px 8px;
  font-size: 0.74rem;
}

.cheque-combinacao-motivos__title {
  color: #1d4ed8;
  font-weight: 800;
  margin-bottom: 3px;
}

.cheque-combinacao-motivos ul {
  margin: 0;
  padding-left: 18px;
}

.cheque-combinacao-motivos li {
  margin-bottom: 2px;
}

@media (max-width: 900px) {
  .receita-criada-grid {
    grid-template-columns: 1fr 1fr;
  }
  .despesa-criada-grid {
    grid-template-columns: 1fr 1fr;
  }  
  .composta-resumo {
    grid-template-columns: 1fr 1fr;
  }  
  .ajuste-valor-composta-grid {
    grid-template-columns: 1fr 1fr;
  }  
}

@media (max-width: 600px) {
  .receita-criada-grid {
    grid-template-columns: 1fr;
  }
  .despesa-criada-grid {
    grid-template-columns: 1fr;
  }  
  .composta-resumo {
    grid-template-columns: 1fr;
  }  
  .ajuste-valor-composta-grid {
    grid-template-columns: 1fr;
  }  
}

@media (max-width: 900px) {
  .confirmacao-receita-grid {
    grid-template-columns: 1fr 1fr;
  }
  .deposito-cheque-resumo,
  .deposito-cheque-grid {
    grid-template-columns: 1fr 1fr;
  }  
}

@media (max-width: 600px) {
  .confirmacao-receita-grid {
    grid-template-columns: 1fr;
  }
  .deposito-cheque-resumo,
  .deposito-cheque-grid {
    grid-template-columns: 1fr;
  }

  .deposito-cheque-item__main {
    flex-direction: column;
  }  
}

@media (max-width: 768px) {
  .ajuste-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .conciliation-summary-grid,
  .review-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .modal-container {
    max-width: 100%;
    max-height: 95vh;
  }

  .section-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .modal-footer {
    flex-wrap: wrap;
    gap: 6px;
  }
}
</style>